window.adSection = window.adSection || 'pd';

// NBBJ OVERRIDES
if(adSection === 'nbbj/news/wine')
	adSection = 'nbbj/industrynews/wineindustry';


// PD OVERRIDES
if(adSection === 'pd/specialsections/sonomagives')
	adSection = 'pd/specialsections/sonomagiving';

if(window.location.href.indexOf('t=2021_drought') !== -1)
	adSection = "pd/specialsections/insight";

if(adSection === 'pd/news/insight')
	adSection = "pd/specialsections/insight";

if(adSection === 'pd/specialsections/fallartsentertainment')
	adSection = 'pd/specialsections/fall-arts';

if(adSection === 'pd/realestate')
	adSection = 'pd/business/realestate';

if(location.hostname.indexOf('pressdemocrat') !== -1 && (window.pageSections || []).indexOf('napa') !== -1) {
	adSection = 'pd/napa';
}

/**
 * This file needs to be loaded after jQuery is loaded, but has no other dependencies.
 *
 * The following script tag is required within the <head> of the html document.
 * <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
 *
 * A query string value of 'dfpDebug=1' on any page running this script will output debug info to the browser console.
 *
 *
 * REQUIRED GLOBALS (apply to all ads on page)
 *
 * Ad Path - which page or section we are targeting ads to
 *   smiDfp.defaultAdSection = 'pd/home' // can be set to any ad path (i.e. pd/sports or pd/lifestyles/food)
 *
 * Ad Breakpoints - at which pixel width we break into a different sized ad. Can define as many as needed
 *   smiDfp.addBreakpoint(bpName, minWidth, maxWidth, renderCSS);   // set render CSS to 'true' for last defined breakpoint
 *
 *   EXAMPLE
 *   smiDfp.addBreakpoint('phone', 0, '767px', false);              // sets breakpoint 'phone' for screens up to 767px wide
 *   smiDfp.addBreakpoint('tablet', '768px', '1024px', false);      // sets breakpoint 'tablet' between 768px & 1024px wide
 *   smiDfp.addBreakpoint('desktop', '1025px', 0, true);            // sets breakpoint 'desktop' for screens 1025px or wider
 *
 *
 * OPTIONAL GLOBALS (apply to all ads on page)
 *
 * Keywords - define keywords to be set for ad services to target for inclusion or exclusion of ads (i.e. wildfire or lawsuit)
 *   smiDfp.addKeyword('wildfire');
 *   smiDfp.addKeyword('lawsuit');
 *   smiDfp.addKeyword('someotherword');
 *
 * Keyword Selectors - required if 'keywords' are defined. Tells the script which jQuery selectors to look for keywords in.
 *   smiDfp.addKeywordSelector('h1:visible');
 *   smiDfp.addKeywordSelector('.article-text');
 *
 * User Experiences - used to change the experiences of individual users. Individual ads can be set to ignore these.
 *    smiDfp.setAdLite();
 *    smiDfp.unsetAdLite();
 *    smiDfp.setAdFree();
 *    smiDfp.unsetAdFree();
 *
 *
 * GLOBAL FUNCTIONS TO BUILD INDIVIDUAL ADS
 *
 * smiDfp.buildAd(visibleFor, style, tag);      // used to create a new ad (i.e. var ad = smiDfp.buildAd('desktop'))
 *                                              // - visibleFor     one or more comma delimited breakpoints as defined by defined by smiDfp.addBreakpoint()
 *                                              // - style          [optional] CSS styles to apply to the ad div (i.e. 'margin: 1em auto; border: 1px solid #000;')
 *                                              // - tag            [optional] Which HTML tag do you want the ad served out of? (default 'div')
 *
 * smiDfp.copy(ad, visibleFor);                 // create a copy of an object created using smiDfp.buildAd()
 *                                              // - ad             object created using smiDfp.buildAd(). Will copy all properties set at point it was copied.
 *                                              // - visibleFor     [optional] If you want the copy visible for different breakpoints. Copies existing if left blank.
 *
 * smiDfp.buildAdWrapper(cssClass, style, tag); // create a wrapper to enclose ad(s) in. Can be used to add styles to parent of ad.
 *                                              // - cssClass       [optional] CSS class you want added to the outer wrapper for the ads.
 *                                              // - style          [optional] CSS styles to apply to the wrapper (i.e. 'margin: 1em auto; border: 1px solid #000;')
 *                                              // - tag            [optional] Which HTML tag do you want the wrapper to be? (default 'div')
 *
 *
 * METHODS USED TO MODIFY ADS
 *
 * addSize(width, height)       // add an available size to the ad tag. Can be used multiple times per ad
 * addTargeting(key, value)     // add a key => value pair to the ad targeting. Can be used multiple times
 * setDelay(milliseconds)       // show the ad this many 'milliseconds' after it is loaded
 * setDeferred()                // Only show the ad when the 'smiDfp.loadDeferredAds()' function is called
 * setShowOnScroll()            // Only show the ad when it scrolls into view
 * setForceReload()             // If the 'smiDfp.refreshAds()' method is called, this ad will reload even if not in viewport
 * setNoReload()                // Prevents an ad from being reloaded by auto-reload
 * setSection(sectionName)      // If targeting a section other than 'smiDfp.defaultAdSection' for this specific ad, use this
 * setShowAdLite()              // This ad will still show, even if this user has chosen the 'Ad Light' experience
 * setShowAdFree()              // This ad will still show, even if this user has chosen the 'Ad Free' experience
 * render()                     // This outputs an HTML tag considering all options above, reday to be injected into the DOM
 * wrapWith(wrapper)            // Same as 'render()' but will append HTML tag into element created by smiDfp.buildAdWrapper()
 *
 * *** methods which control when the ad is displayed should not be combined (setDelay(), setDeferred(), setShowOnScroll()) ***
 * *** methods which control user experience should not be combined (setShowAdLite(), setShowAdFree()) ***
 *
 *
 * GLOBAL FUNCTIONS TO LOAD OR REFRESH ADS
 *
 * smiDfp.loadAds([optional]parentElement);     // processes ALL non-parsed ad tags (within parentElement if defined)
 * smiDfp.loadAd(el);                           // loads a specific ad by passing its ID
 * smiDfp.loadDeferredAds(el);                  // loads a deferred ad by passing its ID or all deferred ads within a parent [el]
 * smiDfp.refreshAds();                         // reloads all ads which are at least 50% in viewport or have forceReload() method applied
 *
 *
 * AD BUILDER CLASS
 *
 * Basic Example - 300x250 | displays in same location and same size on all devices
 *
 *   var ad, adHtml;
 *   ad = smiDfp.buildAd('phone,tablet,desktop');   // phone, tablet, desktop defined as breakpoints above
 *   ad.addSize(300, 250);                          // the ad is a 300x250 unit
 *   adHtml = ad.render();                          // this method compiles all 'ad.' directives into an HTML tag
 *
 *   $('.jQuery.element').html(adHtml);             // insert generated ad HTML into its parent element
 *   smiDfp.loadAds();                              // check entire HTML document for any unprocessed ad tags
 *
 * Intermediate Example - 300x250 mobile, 728x90 tablet & desktop with wrapper
 *
 *   var ad, adHtml, wrapper;
 *   wrapper = smiDfp.buildAdWrapper();             // build an element to wrap ads with (for spacing, border, background, etc.)
 *
 *   ad = smiDfp.buildAd('phone');                  // phone is a defined breakpoint from above
 *   ad.addSize(300, 250);                          // the ad is a 300x250 unit
 *   ad.wrapWith(wrapper);                          // automatically calls 'render()' method and appends HTML to 'wrapper'
 *
 *   ad = smiDfp.buildAd('tablet,desktop');         // tablet & desktop are defined breakpoints from above
 *   ad.addSize(728, 90);                           // the ad is a 728x90 unit
 *   ad.wrapWith(wrapper);                          // automatically calls 'render()' method and appends HTML to 'wrapper'
 *
 *   $('.jQuery.element').html(wrapper);            // insert 'wrapper' into its parent element
 *   smiDfp.loadAds('.jQuery.element');             // only look for unprocessed ad tags within $('.jQuery.element')
 *
 * Intermediate Example - no mobile ad, 728x90 tablet and 728x90 or 970x90 desktop with wrapper and a 4 second delay in loading using copy()
 *
 *   var ad, adHtml, wrapper;
 *   wrapper = smiDfp.buildAdWrapper();             // build an element to wrap ads with (for spacing, border, background, etc.)
 *
 *   ad = smiDfp.buildAd('tablet');                 // tablet is a defined breakpoint from above
 *   ad.setDelay(4000);                             // wait 4 seconds (4000 ms) to load this ad after the code is parsed
 *
 *   ad2 = smiDfp.copy(ad, 'desktop');              // copy above, but set as desktop
 *
 *   ad.addSize(728, 90);                           // 'ad' is a 728x90 unit
 *   ad.wrapWith(wrapper);                          // automatically calls 'render()' method and appends HTML to 'wrapper'
 *
 *   ad2.addSize(728, 90);                           // 'ad2' can be a 728x90 unit
 *   ad2.addSize(970, 90);                           // or it can be a 970x90 unit
 *   ad2.wrapWith(wrapper);                          // automatically calls 'render()' method and appends HTML to 'wrapper'
 *
 *   $('.jQuery.element').html(wrapper);            // insert 'wrapper' into its parent element
 *   smiDfp.loadAds('.jQuery.element');             // only look for unprocessed ad tags within $('.jQuery.element')
 *
 * Advanced Example - 728x90 or 970x90 desktop ad with MOST available methods (some can't be combined and will be covered individually)
 *
 *   var ad, adHtml;
 *
 *   ad = smiDfp.buildAd('desktop');                // desktop is a defined breakpoint from above
 *   ad.setSection('pd/entertainment');             // override the global ad section for just this ad
 *   ad.addSize(728, 90);                           // the ad can be a 728x90 unit
 *   ad.addSize(970, 90);                           // or it can be a 970x90 unit
 *   ad.addTargeting('position', 'ATF');            // add targeting parameters per ad services request
 *   ad.addTargeting('loc', 1);                     // add targeting parameters per ad services request
 *   ad.setDeferred();                              // do not load ad until manually told to do so
 *   ad.setForceReload();                           // reload this ad on request, even if not in viewport
 *   ad.setShowAdLite();                            // still show this ad, even if user has Ad Light experience
 *
 *   adHtml = ad.render();                          // return HTML tag containing relevant ad data
 *   $('#deferred-ad-parent').html(adHtml);         // Insert returned HTML into parent
 *
 *   *** At a time of your choosing (maybe a gallery slide comes into view) ***
 *   smiDfp.loadDeferredAds('#deferred-ad-parent'); // tell parent to look for deferred das and show them
 *
 */

const loadAmazonAds = true;
const refreshVisibleAdsAfter = 35000; // 35 seconds

window.adSection = window.adSection || 'pd';

window.googletag = window.googletag || {};
googletag.cmd = googletag.cmd || [];

// @formatter:off
// https://developers.google.com/doubleclick-gpt/reference
/*(function() {
	var gads = document.createElement("script");
	gads.async = true;
	gads.type = "text/javascript";
	var useSSL = "https:" == document.location.protocol;
	gads.src = (useSSL ? "https:" : "http:") + "//securepubads.g.doubleclick.net/tag/js/gpt.js";
	var node = document.getElementsByTagName("script")[0];
	node.parentNode.insertBefore(gads, node);
})();*/

if(loadAmazonAds) {
	!function(a9,a,p,s,t,A,g){if(a[a9])return;function q(c,r){a[a9]._Q.push([c,r])}a[a9]={init:function(){q("i",arguments)},fetchBids:function(){q("f",arguments)},setDisplayBids:function(){},targetingKeys:function(){return[]},_Q:[]};A=p.createElement(s);A.async=!0;A.src=t;g=p.getElementsByTagName(s)[0];g.parentNode.insertBefore(A,g)}("apstag",window,document,"script","//c.amazon-adsystem.com/aax2/apstag.js");

	apstag.init({
		pubID: 'db83f9c6-a698-4a6a-89fb-c29c85426748',
		adServer: 'googletag',
		schain: {
			complete: 1,
			ver: '1.0',
			nodes: [
				{
					asi: 'yourbow.com',
					sid: '63',
					hp: 1,
				}
			]
		}
	});
}
// @formatter:on


const smiDfp = {};
(function($) {
    'use strict';

    const qs = document.location.search;

    smiDfp.defaultAdSection = adSection;
    smiDfp.logging = 0;
    smiDfp.suppress = 0;

    if(qs.indexOf('dfpDebug=1') !== -1 || qs.indexOf('?dfpdeb') !== -1 || qs.indexOf('&dfpdeb') !== -1)
        smiDfp.logging = 1;

    if(qs.indexOf('suppressDfp=1') !== -1)
        smiDfp.suppress = 1;

    googletag.cmd.push(function() {
        googletag.pubads().set('adsense_background_color', 'FFFFFF');
        if(loadAmazonAds)
            googletag.pubads().disableInitialLoad();
        googletag.pubads().enableAsyncRendering();
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs(true);
        googletag.enableServices();

        googletag.pubads().addEventListener('slotRenderEnded', function(e) {
            var elementId = e.slot.getSlotElementId(),
                adHeight = Array.isArray(e.size) && e.size[1] !== 'undefined' ? e.size[1] : 0,
                adWidth = Array.isArray(e.size) && e.size[0] !== 'undefined' ? e.size[0] : 0,
                adOuter = $('#' + elementId),
                adSlot = adOuter.closest('.dfp-slot'),
                renderedTime = Date.now();

            if(adOuter.length && adSlot.length) {
                adSlot.data('last-rendered', renderedTime).attr('data-last-rendered', renderedTime).removeClass('dfp-refreshing');

                adSlot.addClass('dfp-rendered').css({minHeight: adHeight});

                //adSlot.trigger('dfpRendered', e);
                $(document).trigger('dfpRendered', [adSlot, e]);

                if(smiDfp.logging) console.log('DFP:', ' - ' + elementId + ' rendered', adSlot);

                if(e.isEmpty) {
                    if(smiDfp.logging) console.log('DFP:', '  - dfp reported slot is empty');
                    adSlot.removeClass('dfp-rendered').css({minHeight: 0});
                }

                if(smiDfp.logging && e.isBackfill) console.log('DFP:', '  - dfp reported slot is backfill');

                if(smiDfp.logging && !e.slotContentChanged) console.log('DFP:', '  - dfp reported slot content did not change');
            }
        });
    });

    function onDfpLoaded(callback, iteration) {
        if(!iteration) iteration = 1;

        if(window.googletag && googletag.pubadsReady) {
            if(typeof callback === 'function') {
                callback.call(this);
            }
        } else {
            if(iteration++ <= 8) {
                setTimeout(function() {
                    onDfpLoaded(callback, iteration);
                }, 250);
            }
        }
    }

    function isInViewport(el) {
        if(el instanceof $) el = el[0];

        var rect = typeof el.getBoundingClientRect === 'function' ? el.getBoundingClientRect() : null,
            vHeight = jQuery(window).height(),
            vWidth = jQuery(window).width();

        if(rect) {
            return (
                rect.top >= -(rect.height / 2) &&
                rect.left >= 0 &&
                rect.bottom <= vHeight + (rect.height / 2) &&
                rect.right <= vWidth
            );
        }
        return false;
    }

    smiDfp.renderedAds = [];
    smiDfp.foundKeywords = [];
    smiDfp.globalTargeting = {};

    function showAd(el, delay) {
        if(smiDfp.suppress) return;

        var size = el.data('size'),
            targeting = el.data('targeting'),
            adId = el.attr('id'),
            adSection = el.data('dfp'),
            adSectionFull, thisAd;

        if(adSection && typeof adSection !== undefined) {
            if(size && typeof size !== undefined) {
                var inner = $('<div />');

                el.addClass('dfp-rendering').html(inner);
                el.attr('id', '');
                inner.attr('id', adId);

                adSectionFull = '/94238257/' + adSection;
                thisAd = googletag.defineSlot(adSectionFull, size, adId);

                if(!$.isEmptyObject(smiDfp.globalTargeting)) {
                    $.each(smiDfp.globalTargeting, function(k, v) {
                        thisAd.setTargeting(k, v);
                    });
                }

                if(smiDfp.foundKeywords.length) {
                    thisAd.setTargeting('keyword', smiDfp.foundKeywords);
                }

                if(targeting && typeof targeting !== undefined) {
                    $.each(targeting, function(k, v) {
                        thisAd.setTargeting(k, v);
                    });
                }

                var loadAmazonAdsIfEnabled = function() {
                    if(loadAmazonAds) {
                        apstag.fetchBids({
                            slots  : [{
                                slotID  : adId,
                                slotName: adSectionFull,
                                sizes   : size //example: [[300,250], [300,600]]
                            }],
                            timeout: 2e3
                        }, function(bids) {
                            googletag.cmd.push(function() {
                                apstag.setDisplayBids();
                                googletag.pubads().refresh([thisAd]);
                            });
                        });
                    }
                };

                delay = parseInt(delay);
                if(isNaN(delay)) delay = 0;
                setTimeout(function() {
                    if(smiDfp.logging) console.log('DFP:', '-- calling ' + adId);
                    thisAd.addService(googletag.pubads());
                    smiDfp.renderedAds[adId] = thisAd;
                    googletag.display(adId);

                    loadAmazonAdsIfEnabled();
                }, delay);
            }
        } else {
            if(smiDfp.logging)
                console.log('DFP:', 'Unable to render ads. An ad section needs to be defined globally using the variable \'smiDfp.defaultAdSection\'.');
        }
    }

    let deferredDfpAdCount = 1;

    function showDeferredAd(el) {
        googletag.cmd.push(function() {
            var deferredId = el.data('id') + '-d' + deferredDfpAdCount++;
            el.attr('data-deferred', 0).attr('id', deferredId);
            showAd(el);
        });
    }

    function showScrollToAd(el) {
        googletag.cmd.push(function() {
            el.data('onscroll', 0).attr('data-onscroll', 0);
            showAd(el);
        });
    }

    let adGroup = 0,
        dfpLoaderRunning = 0,
        dfpLoaderIteration = 0;

    smiDfp.loadAds = function(parentElement) {
        if(dfpLoaderRunning) {
            if(dfpLoaderIteration++ <= 50) {
                setTimeout(function() {
                    smiDfp.loadAds(parentElement);
                }, 250);
            }
        } else {
            dfpLoaderIteration = 0;
            dfpLoaderRunning = 1;
            adGroup++;

            var $body = $('body'), $el;
            if(parentElement) $el = (typeof parentElement === 'string' || parentElement instanceof String) ? $(parentElement) : parentElement;
            else $el = $body;

            onDfpLoaded(function() {
                //$el.find(".dfp-slot:hidden").not("[data-deferred=1]").remove();

                if($body.hasClass('ad-lite')) {
                    $el.find('.dfp-slot').not('.show-ad-lite').not('.show-ad-free').remove();
                }

                if($body.hasClass('ad-free')) {
                    $el.find('.dfp-slot').not('.show-ad-free').remove();
                }

                $el.find('.dfp-wrap:empty').remove();

                var adTagsAvailable = $el.find('.dfp-slot').filter(':visible').not('.dfp-rendering');
                if(adTagsAvailable.length) {
                    if(smiDfp.logging) console.log('DFP:', adTagsAvailable.length + ' dfp slot(s) will be rendered');

                    var adsToDisplay = adTagsAvailable.not('[data-deferred=1]').not('[data-onscroll=1]').not('[data-delayed]');
                    if(smiDfp.logging && adsToDisplay.length) console.log('DFP:', '- ' + adsToDisplay.length + ' slot(s) will display immediately');

                    var adsToDelay = adTagsAvailable.filter('[data-delayed]');
                    if(smiDfp.logging && adsToDelay.length) console.log('DFP:', '- ' + adsToDelay.length + ' slot(s) will display with a delay');

                    var adsToShowOnScroll = adTagsAvailable.filter('[data-onscroll=1]');
                    if(smiDfp.logging && adsToShowOnScroll.length) console.log('DFP:', '- ' + adsToShowOnScroll.length + ' slot(s) will be lazy loaded');

                    var deferredAds = adTagsAvailable.filter('[data-deferred=1]');
                    if(smiDfp.logging && deferredAds.length) console.log('DFP:', '- ' + deferredAds.length + ' slot(s) will display when triggered');

                    if(!$.isEmptyObject(smiDfp.globalTargeting)) {
                        if(smiDfp.logging) {
                            console.log('DFP:', '-- the following \'key => value\' pairs will be added to the targeting of all ads:');
                            $.each(smiDfp.globalTargeting, function(k, v) {
                                console.log('DFP:', ' - ' + k + ' => ' + v);
                            });
                        }
                    }

                    if(keywords && keywordSelectors) {
                        if(smiDfp.logging)
                            console.log('DFP:', '-- looking for keywords [' + keywords.join(', ') + '] in selectors [' + keywordSelectors.join(', ') + ']');

                        $.each(keywordSelectors, function(s, selector) {
                            var text = $el.find(selector).text().toLowerCase();
                            if(text.length > 100) {
                                if(smiDfp.logging)
                                    console.log('DFP:', ' - Text Length: ' + text.length);

                                $.each(keywords, function(k, keyword) {
                                    var kw, pos;
                                    kw = keyword.toLowerCase();
                                    pos = text.indexOf(kw);
                                    if(pos > 10) {
                                        if(smiDfp.logging)
                                            console.log('DFP:', ' - Keyword \'' + keyword + '\' found at ' + pos);

                                        if(smiDfp.foundKeywords.indexOf(keyword) === -1)
                                            smiDfp.foundKeywords.push(keyword);
                                    } else {
                                        if(smiDfp.logging)
                                            console.log('DFP:', ' - Keyword \'' + keyword + '\' not found');
                                    }
                                });
                            }
                        });
                    }

                    if(adsToDisplay.length || adsToDelay.length) {
                        googletag.cmd.push(function() {
                            $.each(adsToDisplay.add(adsToDelay), function() {
                                var adTag = $(this),
                                    delay = adTag.data('delayed');

                                showAd(adTag, delay);
                            });
                        });
                    }

                    var adsNotCurrentlyInView = [];
                    if(adsToShowOnScroll.length) {
                        $.each(adsToShowOnScroll, function() {
                            if(isInViewport($(this))) {
                                showScrollToAd($(this));
                            } else {
                                adsNotCurrentlyInView.push($(this));
                            }
                        });
                    }

                    if(adsNotCurrentlyInView.length) {
                        var scrollEvent = 'scroll.smidfp.delayed.' + adGroup,
                            hasScrolled = false,
                            scrollInterval;

                        $(window).on(scrollEvent, function() {
                            hasScrolled = true;
                        });

                        scrollInterval = setInterval(function() {
                            if(hasScrolled) {
                                hasScrolled = false;
                                var onscrollAds = adTagsAvailable.filter('[data-onscroll=1]');
                                if(onscrollAds.length) {
                                    $.each(onscrollAds, function() {
                                        if(isInViewport($(this))) {
                                            showScrollToAd($(this));
                                        }
                                    });
                                } else {
                                    $(window).off(scrollEvent);
                                    clearInterval(scrollInterval);
                                }
                            }
                        }, 350);
                    }

                }
                dfpLoaderRunning = 0;
            });
        }
    };

    smiDfp.loadAd = function(el) {
        googletag.cmd.push(function() {
            el = (typeof el === 'string' || el instanceof String) ? $(el) : el;
            showAd(el);
        });
    };

    smiDfp.loadDeferredAds = function(el) {
        el = (typeof el === 'string' || el instanceof String) ? $(el) : el;

        //el.find(".dfp-slot[data-deferred=1]:hidden").remove();
        //el.find(".dfp-wrap:empty").remove();

        var element = el.find('.dfp-slot[data-deferred=1]:visible');
        if(!element.length) {
            //el.filter(".dfp-slot[data-deferred=1]:hidden").remove();
            //el.filter(".dfp-wrap:empty").remove();
            element = el.filter('[data-deferred=1]');
        }

        if(element.length) {
            $.each(element, function() {
                showDeferredAd($(this));
            });
        }
    };

    smiDfp.refreshAds = function() {
        onDfpLoaded(function() {
            var adSlots = $('.dfp-slot').filter(':visible').not('[data-deferred=1]'),
                adOuter, adElement, forceReload;
            if(adSlots.length) {
                $.each(adSlots, function() {
                    adOuter = $(this);
                    adElement = $(this).find('div:first');
                    forceReload = adOuter.data('force-reload');
                    if(isInViewport(adOuter) || (forceReload && forceReload !== 'undefined')) {
                        smiDfp.refreshAd(adOuter, true);
                    }
                });
            }
        });
    };

    smiDfp.refreshVisibleAds = function() {
        onDfpLoaded(function() {
            if(refreshVisibleAdsAfter && !pageIsIdle) {
                $('.dfp-slot[data-last-rendered]:visible').not('.dfp-refreshing').not('.dfp-no-reload').filter(function() {
                    var dfpSlot = $(this),
                        lastRendered = dfpSlot.data('last-rendered') || 0,
                        refreshAfter = (lastRendered + refreshVisibleAdsAfter);
                    return isInViewport(dfpSlot) && (refreshAfter < Date.now());
                }).each(function() {
                    smiDfp.refreshAd($(this));
                });
            }
        });
    };

    smiDfp.refreshAd = function(dfpSlot, ignoreTimer) {
        var lastRendered = dfpSlot.data('last-rendered') || 0,
            isRefreshing = dfpSlot.hasClass('dfp-refreshing'),
            refreshAfter = (lastRendered + refreshVisibleAdsAfter),
            refreshAds = !!refreshVisibleAdsAfter,
            adElement, adElementId;

        if(!refreshAds) return;

        if(isRefreshing) return;

        if(!ignoreTimer && Date.now() < refreshAfter) return;

        adElementId = dfpSlot.find('div:first').attr('id') || false;
        adElement = smiDfp.renderedAds[adElementId] || false;

        if(adElement && adElementId) {
            if(smiDfp.logging) console.log('DFP:', 'refreshing ' + adElementId, dfpSlot);
            dfpSlot.addClass('dfp-refreshing');
            googletag.pubads().refresh([adElement], {changeCorrelator: false});
        }
    };

    smiDfp.addGlobalTargeting = function(key, value) {
        smiDfp.globalTargeting[key] = value;
    };

    var adCount = 0,
        breakpoints = [],
        keywords = [],
        keywordSelectors = [];

    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if('value' in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function(Constructor, protoProps, staticProps) {
            if(protoProps) defineProperties(Constructor.prototype, protoProps);
            if(staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _classCallCheck(instance, Constructor) {
        if(!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function');
        }
    }

    var adBuilder = function() {
        function adBuilder(visibleFor, cssClass, style, tag) {
            _classCallCheck(this, adBuilder);

            this.showAdLite = 0;
            this.showAdFree = 0;
            this.delayed = 0;
            this.deferred = 0;
            this.showOnScroll = 0;
            this.forceReload = 0;
            this.noReload = 0;
            this.sizes = [];
            this.attributes = {};
            this.targeting = {};
            this.visibleFor = visibleFor;
            this.class = cssClass;
            this.style = style;
            if(!tag) tag = 'div';
            this.tag = tag;
            this.section = smiDfp.defaultAdSection;
            this.id = 'ad-' + adCount++;
        }

        _createClass(adBuilder, [{
            key  : 'addSize',
            value: function addSize(width, height) {
                this.sizes.push({width: width, height: height});
                return this;
            }
        }, {
            key  : 'addAttribute',
            value: function addAttribute(key, value) {
                this.attributes[key] = value;
                return this;
            }
        }, {
            key  : 'addTargeting',
            value: function addTargeting(key, value) {
                this.targeting[key] = value;
                return this;
            }
        }, {
            key  : 'setDelay',
            value: function setDelay(milliseconds) {
                this.delayed = milliseconds;
                return this;
            }
        }, {
            key  : 'setDeferred',
            value: function setDeferred() {
                this.deferred = true;
                return this;
            }
        }, {
            key  : 'setShowOnScroll',
            value: function setShowOnScroll() {
                this.showOnScroll = true;
                return this;
            }
        }, {
            key  : 'setForceReload',
            value: function setForceReload() {
                this.forceReload = true;
                return this;
            }
        }, {
            key  : 'setNoReload',
            value: function setNoReload() {
                this.noReload = true;
                return this;
            }
        }, {
            key  : 'setSection',
            value: function setSection(newSection) {
                this.section = newSection;
                return this;
            }
        }, {
            key  : 'setShowAdLite',
            value: function setShowAdLite() {
                this.showAdLite = true;
                return this;
            }
        }, {
            key  : 'setShowAdFree',
            value: function setShowAdFree() {
                this.showAdFree = true;
                return this;
            }
        }, {
            key  : 'render',
            value: function render() {
                if(this.visibleFor && this.sizes.length) {
                    var tag = $('<' + this.tag + ' />'),
                        firstSize = this.sizes[0],
                        sizes = [];

                    this.id += '-' + firstSize.width + 'x' + firstSize.height;
                    if(this.deferred) {
                        tag.attr('data-deferred', 1);
                    } else {
                        if(this.showOnScroll) {
                            tag.attr('data-onscroll', 1);
                        } else if(this.delayed) {
                            tag.attr('data-delayed', this.delayed);
                        }
                    }

                    tag.addClass('dfp-slot').attr('data-dfp', this.section);

                    if(this.class) tag.addClass(this.class);
                    if(this.style) tag.attr('style', this.style);
                    if(this.forceReload) tag.attr('data-force-reload', 1);
                    if(this.noReload) tag.addClass('dfp-no-reload');
                    if(this.showAdLite) tag.addClass('show-ad-lite');
                    if(this.showAdFree) tag.addClass('show-ad-free');

                    $.each(this.sizes, function(i, v) {
                        sizes.push([v.width, v.height]);
                    });

                    if(sizes.length === 1) {
                        tag.attr('data-size', JSON.stringify(sizes[0]));
                    } else {
                        tag.attr('data-size', JSON.stringify(sizes));
                    }

                    if(Object.getOwnPropertyNames(this.attributes).length) {
                        $.each(this.attributes, function(attribute, value) {
                            tag.attr(attribute, value);
                        });
                    }

                    if(Object.getOwnPropertyNames(this.targeting).length) {
                        tag.attr('data-targeting', JSON.stringify(this.targeting));
                    }

                    var theTags = [],
                        theId = this.id,
                        isDeferred = this.deferred;

                    $.each(this.visibleFor.split(','), function(i, visibleFor) {
                        var thisTag = tag.clone(true),
                            thisId = theId + '-' + visibleFor;
                        thisTag.addClass('dfp-slot-' + visibleFor);
                        if(isDeferred) {
                            thisTag.attr('data-id', thisId);
                        } else {
                            thisTag.attr('id', thisId);
                        }
                        theTags.push(thisTag);
                    });

                    return theTags;
                }
                return false;
            }
        }, {
            key  : 'wrapWith',
            value: function wrapWith(wrapper) {
                var tag = this.render();
                wrapper.append(tag);
            }
        }], [{
            key  : 'copy',
            value: function copy(ad, visibleFor) {
                var ad2 = ad;
                ad2.visibleFor = visibleFor ? visibleFor : ad.visibleFor;
                ad2.id = 'ad-' + adCount++ + '-' + ad2.visibleFor.replace(/\,/g, '-');
                return ad2;
            }
        }, {
            key  : 'buildAdShim',
            value: function buildAdShim(visibleFor, height, width, tag) {
                if(!width) width = '100%';
                if(!tag) tag = 'div';
                tag = $('<' + tag + ' />', {
                    'class': 'dfp-slot',
                    'style': 'height:' + height + ';width:' + width + ';'
                });
                visibleFor = visibleFor.split(',');
                $.each(visibleFor, function(i, v) {
                    tag.addClass('dfp-slot-' + v);
                });
                return tag;
            }
        }, {
            key  : 'buildAdWrap',
            value: function buildAdWrap(cssClass, style, tag) {
                if(!tag) tag = 'div';
                var wrap = $('<' + tag + ' />', {'class': 'dfp-wrap'});
                if(cssClass) wrap.addClass(cssClass);
                if(style) wrap.attr('style', style);
                return wrap;
            }
        }, {
            key  : 'addKeyword',
            value: function addKeyword(keyword) {
                keywords.push(keyword);
                return this;
            }
        }, {
            key  : 'addKeywordSelector',
            value: function addKeywordSelector(selector) {
                keywordSelectors.push(selector);
                return this;
            }
        }, {
            key  : 'addBreakpoint',
            value: function addBreakpoint(name, minWidth, maxWidth, buildCss) {
                breakpoints.push({
                    'name'    : name,
                    'minWidth': minWidth,
                    'maxWidth': maxWidth
                });
                buildCss = buildCss !== undefined ? buildCss : true;
                if(buildCss) this.renderBreakpointCSS();
            }
        }, {
            key  : 'renderBreakpointCSS',
            value: function renderBreakpointCSS() {
                var tag = $('style#dfp-breakpoint-css'),
                style;

                if(!tag.length)
                    tag = $('<style id="dfp-breakpoint-css"/>').appendTo('head');

                style = '.dfp-slot, .dfp-wrap { display: block; text-align: center; }';
                style += '.ad-lite .dfp-slot, .ad-free .dfp-slot { display: none; }';
                style += '.ad-lite .show-ad-lite .dfp-slot, .ad-lite .show-ad-free .dfp-slot, .ad-free .show-ad-free .dfp-slot { display: block; }';
                style += '.ad-lite .dfp-slot.show-ad-lite, .ad-lite .dfp-slot.show-ad-free, .ad-free .dfp-slot.show-ad-free { display: block; }';
                $.each(breakpoints, function(i, v) {
                    const min = !v.minWidth || isNaN(parseFloat(v.minWidth)) || !isFinite(v.minWidth) ? v.minWidth : (parseFloat(v.minWidth) - 1) + 'px';
                    const max = !v.maxWidth || isNaN(parseFloat(v.maxWidth)) || !isFinite(v.maxWidth) ? v.maxWidth : (parseFloat(v.maxWidth) + 1) + 'px';

                    if(min && max) {
                        style += '@media screen and (max-width: ' + min + ') {';
                        style += '.dfp-slot-' + v.name + ' { display: none !important; }';
                        style += '}';
                        style += '@media screen and (min-width: ' + max + ') {';
                        style += '.dfp-slot-' + v.name + ' { display: none !important; }';
                        style += '}';
                    } else if(min && !max) {
                        style += '@media screen and (max-width: ' + min + ') {';
                        style += '.dfp-slot-' + v.name + ' { display: none !important; }';
                        style += '}';
                    } else if(max && !min) {
                        style += '@media screen and (min-width: ' + max + ') {';
                        style += '.dfp-slot-' + v.name + ' { display: none !important; }';
                        style += '}';
                    }
                });
                tag.html(style);
            }
        }]);

        return adBuilder;
    }();

    smiDfp.buildAd = function(visibleFor, cssClass, style, tag) {
        return new adBuilder(visibleFor, cssClass, style, tag);
    };

    smiDfp.copy = function(ad, visibleFor) {
        return adBuilder.copy(ad, visibleFor);
    };

    smiDfp.buildAdWrapper = function(cssClass, style, tag) {
        return adBuilder.buildAdWrap(cssClass, style, tag);
    };

    smiDfp.buildAdShim = function(visibleFor, height, width, tag) {
        return adBuilder.buildAdShim(visibleFor, height, width, tag);
    };

    smiDfp.addKeyword = function(keyword) {
        adBuilder.addKeyword(keyword);
    };

    smiDfp.addKeywordSelector = function(selector) {
        adBuilder.addKeywordSelector(selector);
    };

    smiDfp.addBreakpoint = function(name, minWidth, maxWidth, buildCss) {
        adBuilder.addBreakpoint(name, minWidth, maxWidth, buildCss);
    };

    smiDfp.setAdLite = function() {
        $('body').addClass('ad-lite');
    };

    smiDfp.unsetAdLite = function() {
        $('body').removeClass('ad-lite');
    };

    smiDfp.setAdFree = function() {
        $('body').addClass('ad-free');
    };

    smiDfp.unsetAdFree = function() {
        $('body').removeClass('ad-free');
    };

    smiDfp.buildCubeAd = function(el, breakpoints, targeting, delay, className) {
        delay = delay ? delay : 500;

        var cubeAd = smiDfp.buildAd(breakpoints, className);
        cubeAd.addSize(300, 250);
        if(delay) cubeAd.setDelay(delay);
        if(targeting) {
            $.each(JSON.parse(targeting), function(key, value) {
                cubeAd.addTargeting(key, value);
            });
        }

        $(el).html(cubeAd.render());
    };

    var resizeTimer; // debounced
    $(window).on('resize orientationchange', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            smiDfp.loadAds();
        }, 350);
    });

    var hasScrolled = false,
        pageIsIdle = true,
        pageIdleTimer;
    $(window).on('scroll.dfpLoader', function() {
        hasScrolled = true;
    });

    setInterval(function() {
        if(hasScrolled) {
            pageIsIdle = false;
            hasScrolled = false;
            smiDfp.refreshVisibleAds();

            clearTimeout(pageIdleTimer);
            pageIdleTimer = setTimeout(function() {
                pageIsIdle = true;
            }, 60000);
        }
    }, 500);

    setInterval(function() {
        smiDfp.refreshVisibleAds();
    }, 5000);

    window.addEventListener('message', function(event) {
        if(event.data === 'dfpIsRichMedia') {
            var adId = event.source.frameElement.id;
            jQuery(function($) {
                $('[id="' + adId + '"]').closest('.dfp-slot').addClass('dfp-no-reload');
            });
        }
    }, false);
})(jQuery);
const cphHost = window.location.hostname;
let cphPD, cphSIT, cphPAC, cphNBBJ, cphSCG, cphLPS, cphDomain, cphNlHost, cphCookieDomain, cphPubName, cphPubAbbrev,
    cphFeedDir, cphEnv;

cphCookieDomain = cphHost;
(function() {
    let pdHosts = ['www.pressdemocrat.com', 'preview.pressdemocrat.com', 'stage.pressdemocrat.com', 'navweb.pressdemocrat.com', 'site.stage.ew.srp.navigacloud.com', 'site.everywarestarterkit.local'];
    let sitHosts = ['www.sonomanews.com', 'preview.sonomanews.com', 'stage.sonomanews.com', 'navweb.sonomanews.com', 'sit.stage.ew.srp.navigacloud.com', 'sit.everywarestarterkit.local'];
    let pacHosts = ['www.petaluma360.com', 'preview.petaluma360.com', 'stage.petaluma360.com', 'navweb.petaluma360.com', 'pac.stage.ew.srp.navigacloud.com', 'pac.everywarestarterkit.local'];
    let nbbjHosts = ['www.northbaybusinessjournal.com', 'preview.northbaybusinessjournal.com', 'stage.northbaybusinessjournal.com', 'navweb.northbaybusinessjournal.com', 'nbbj.stage.ew.srp.navigacloud.com', 'nbbj.everywarestarterkit.local'];
    let scgHosts = ['www.sonomacountygazette.com', 'preview.sonomacountygazette.com', 'stage.sonomacountygazette.com', 'navweb.sonomacountygazette.com', 'scg.stage.ew.srp.navigacloud.com', 'scg.everywarestarterkit.local'];
    let lpsHosts = ['www.laprensasonoma.com', 'preview.laprensasonoma.com', 'stage.laprensasonoma.com', 'navweb.laprensasonoma.com', 'lps.prod.ew.srp.navigacloud.com', 'lps.stage.ew.srp.navigacloud.com', 'lps.everywarestarterkit.local'];

    if(sitHosts.indexOf(cphHost) !== -1) {
        cphSIT = true;
        cphDomain = 'sonomanews.com';
        cphPubName = 'Sonoma Index-Tribune';
        cphPubAbbrev = 'sit';
        cphFeedDir = 'sit2018';
    } else if(pacHosts.indexOf(cphHost) !== -1) {
        cphPAC = true;
        cphDomain = 'petaluma360.com';
        cphPubName = 'Petaluma Argus-Courier';
        cphPubAbbrev = 'pac';
        cphFeedDir = 'pac2018';
    } else if(nbbjHosts.indexOf(cphHost) !== -1) {
        cphNBBJ = true;
        cphDomain = 'northbaybusinessjournal.com';
        cphPubName = 'North Bay Business Journal';
        cphPubAbbrev = 'nbbj';
        cphFeedDir = 'nbbj2018';
    } else if(scgHosts.indexOf(cphHost) !== -1) {
        cphSCG = true;
        cphDomain = 'sonomacountygazette.com';
        cphPubName = 'Sonoma County Gazette';
        cphPubAbbrev = 'scg';
        cphFeedDir = 'scg2018';
    } else if(lpsHosts.indexOf(cphHost) !== -1) {
        cphLPS = true;
        cphDomain = 'laprensasonoma.com';
        cphPubName = 'La Prensa Sonoma';
        cphPubAbbrev = 'lps';
        cphFeedDir = 'lps2018';
    } else {
        cphPD = true;
        cphDomain = 'pressdemocrat.com';
        cphPubName = 'Press Democrat';
        cphPubAbbrev = 'pd';
        cphFeedDir = 'pd2018';
    }

    cphNlHost = 'https://newsletter.' + cphDomain;

    let cookieDomainParts = cphCookieDomain.split('.');
    let topLevel = cookieDomainParts.shift();
    if(topLevel === 'www' || topLevel === 'navweb') // remove www only if top-level
        cphCookieDomain = '.' + cookieDomainParts.join('.');
})();

if(cphHost.indexOf('stage.') === 0 || cphHost.indexOf('stage.ew.srp.navigacloud.com') !== -1 || cphHost.indexOf('everywarestarterkit.local') !== -1) {
    cphEnv = 'test';
} else {
    cphEnv = 'prod';
}

// @formatter:off
/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function(b,c){let $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){let h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){let o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);
// @formatter:on

var cphGlobal = window.cphGlobal || {};
cphGlobal.isProd = function() {
    return cphEnv === 'prod';
};

cphGlobal.isStage = function() {
    return cphEnv === 'test';
};

(function($) {
    cphGlobal.pageIsMetered = function() {
        let pageData = window.mg2PageData || {};
        return !!pageData.metered || !!pageData.thick || !!pageData.premium;
    };

    cphGlobal.pageIsPremium = function() {
        let pageData = window.mg2PageData || {};
        return !!pageData.premium;
    };

    cphGlobal.pageIsGifted = function() {
        let pageData = window.mg2PageData || {};
        return !!pageData.gifted;
    };

    cphGlobal.copyTextToClipboard = function(text, onSuccess, onFail) {
        const callOnSuccess = function() {
            if(typeof onSuccess === 'function') onSuccess.call();
        };

        const callOnFail = function(failReason) {
            console.log(failReason);
            if(typeof onFail === 'function') onFail.call();
        };

        const onClipboardApiFail = function(failReason) {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.contentEditable = 'true';
            textArea.readOnly = true;
            textArea.style.position = 'absolute';
            textArea.style.left = '-9999px';

            document.body.appendChild(textArea);
            //textArea.focus();
            textArea.select();

            let success = false;
            try {
                success = !!document.execCommand('copy');
            } catch(err) {
                // fail silently
            }

            document.body.removeChild(textArea);

            if(success) callOnSuccess();
            if(!success) callOnFail(failReason);
        };

        if(window.navigator && navigator.clipboard && navigator.clipboard.writeText) {
            try {
                navigator.clipboard.writeText(text).then(function() {
                    callOnSuccess();
                }, function() {
                    onClipboardApiFail('navigator.clipboard.writeText() failed.');
                });
            } catch(err) {
                onClipboardApiFail('Unable to write to clipboard. ' + err);
                // https://developer.apple.com/forums/thread/691873
                // https://stackoverflow.com/questions/57278923/chrome-76-copy-content-to-clipboard-using-navigator
            }
            return;
        }

        onClipboardApiFail('Clipboard API not available.');
    };

    cphGlobal.hasLocalStorage = function() {
        if(typeof cphGlobal.localStorageChecked !== 'boolean') {
            var mod = 'localStorageCheck';
            try {
                localStorage.setItem(mod, mod);
                localStorage.removeItem(mod);
                cphGlobal.localStorageChecked = true;
            } catch(e) {
                cphGlobal.localStorageChecked = false;
            }
        }
        return cphGlobal.localStorageChecked;
    };

    cphGlobal.hasSessionStorage = function() {
        if(typeof cphGlobal.sessionStorageChecked !== 'boolean') {
            var mod = 'sessionStorageCheck';
            try {
                sessionStorage.setItem(mod, mod);
                sessionStorage.removeItem(mod);
                cphGlobal.sessionStorageChecked = true;
            } catch(e) {
                cphGlobal.sessionStorageChecked = false;
            }
        }
        return cphGlobal.sessionStorageChecked;
    };

    cphGlobal.dateYMD = function(dateString) {
        var date = new Date(dateString),
            year = date.toLocaleString('default', {year: 'numeric'}),
            month = date.toLocaleString('default', {month: '2-digit'}),
            day = date.toLocaleString('default', {day: '2-digit'});
        return year + '-' + month + '-' + day;
    };

    cphGlobal.hasFloatedObstacle = function(el, parent) {
        if(!parent) parent = el.parent();

        var widthCheck = $('<div/>', {style: 'display: block; margin: 0; padding: 0; height: 0; overflow: hidden;'}),
            elWidth;

        widthCheck.insertBefore(el);
        elWidth = widthCheck.width();

        widthCheck.remove();

        return elWidth !== parent.width();
    };

    cphGlobal.hasCcpaCookieValue = function(value, cookieName) {
        if(!cookieName) cookieName = 'ccpaPrefs';
        var ccpaCookie = decodeURIComponent(cphGlobal.getCookieByName(cookieName));
        if(ccpaCookie && ccpaCookie.length) {
            var values = ccpaCookie.split(/\s*,\s*/);
            return values.indexOf(value) !== -1;
        }
        return false;
    };

    cphGlobal.buildNotification = function(id, type, position, priority, html, closeFor, hideIcon, outerClass) {
        const cookieName = 'noti_' + id;

        outerClass = outerClass || '';

        if(!cphGlobal.getCookieByName(cookieName) || cphGlobal.getQueryStringValueByKey('notiPreview') === 'true') {
            var inner = $('<div />').addClass('notification-container').html(html),
                container = $('<div />', {'class': 'padded container', 'html': inner}),
                wrap = $('<div />', {'class': 'notification ' + type + ' ' + outerClass, 'id': id, 'html': container}),
                hasButton = wrap.find('button, .button');

            if(!hideIcon) wrap.addClass('has-icon');

            if(hasButton.length) wrap.addClass('has-button');

            if(closeFor !== 'na') {
                var close = $('<span />', {'class': 'notification-close'}).prependTo(wrap),
                    altClose = wrap.find('[data-action=close]'),
                    days = closeFor,
                    date, expires;

                if($.isNumeric(days)) {
                    date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = '; expires=' + date.toGMTString();
                } else {
                    expires = '';
                }

                close.one('click', function() {
                    document.cookie = cookieName + '=1' + expires + '; path=/';
                    wrap.slideUp(180, function() {
                        $(this).remove();
                    });
                });

                if(altClose.length) {
                    close.hide();
                    altClose.click(function() {
                        close.trigger('click');
                    });
                }
            }

            if(position === 'top') {
                $('#top-notifications').append(wrap);
            } else if(position === 'bottom') {
                $('#bottom-notifications').append(wrap);
            }
        }
    };

    cphGlobal.wrapWithFigure = function(element, caption) {
        var figure = $('<figure>', {
            html: $('<div>', {
                class: 'pd-figure-outer-wrap',
                html : $('<div>', {
                    class: 'pd-figure-inner-wrap',
                    html : element
                })
            })
        });
        if(caption && caption !== 'undefined') {
            $('<figcaption>', {
                html: $('<div>', {
                    class: 'pd-figcaption-inner-wrap',
                    html : caption
                })
            }).appendTo(figure);
        }
        return figure;
    };

    cphGlobal.wrapFigures = function(figures, size, position) {
        return $('<div>', {
            class: 'pd-shortcode-widget',
            html : figures
        }).addClass('pd-widget-size-' + size).addClass('pd-widget-position-' + position);
    };

    cphGlobal.getQueryStringValueByKey = function(key, url) {
        if(!url) url = window.location.href;
        key = key.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + key + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if(!results) return null;
        if(!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    cphGlobal.getQueryStringParameter = function(key, url) {
        // alias for cphGlobal.getQueryStringValueByKey()
        return cphGlobal.getQueryStringValueByKey(key, url);
    };

    cphGlobal.updateQueryStringParameter = function(key, value, url) {
        if(!url) url = window.location.href;

        var i = url.indexOf('#');
        var hash = i === -1 ? '' : url.substr(i);
        url = i === -1 ? url : url.substr(0, i);

        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        if(value === false) {
            if(url.match(re)) {
                url = url.replace(re, '$1');
            }
        } else {
            if(url.match(re)) {
                url = url.replace(re, '$1' + key + '=' + value + '$2');
            } else {
                url = url + separator + key + '=' + value;
            }
        }
        url = url.replace(/([\?\&]+)$/, ''); // added to remove ? or & at end of url if present
        return url + hash;
    };

    cphGlobal.exitIntent = function(callback, activeAfter, intentAfter) {
        activeAfter = (activeAfter) ? parseInt(activeAfter) : 5000;
        intentAfter = (intentAfter) ? parseInt(intentAfter) : 350;

        if(typeof callback === 'function') {
            cphGlobal.exitIntentTrigger = setTimeout(function() {
                var exitTimer;
                $(document).on('mouseout.cphExitIntent', function(e) {
                    if(!$(e.toElement).length && e.relatedTarget === null) {
                        clearTimeout(cphGlobal.exitIntentTrigger);
                        exitTimer = setTimeout(function() {
                            $(document).off('.cphExitIntent');
                            callback.call();
                        }, intentAfter); // give 350ms to get back in bounds
                    } else {
                        clearTimeout(exitTimer);
                    }
                });
            }, activeAfter); // have user on page for at least 5 seconds before this can be triggered
        }
    };

    cphGlobal.replaceUrl = function(newUrl) {
        history.replaceState({}, '', newUrl);
    };

    cphGlobal.cookiesEnabled = function() {
        try {
            document.cookie = 'cookietest=1';
            var ret = document.cookie.indexOf('cookietest=') !== -1;
            document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
            return ret;
        } catch(e) {
            return false;
        }
    };

    cphGlobal.setCookie = function(name, value, days) {
        var expires;
        if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = ';expires=' + date.toUTCString();
        } else {
            expires = '';
        }
        document.cookie = name + '=' + value + expires + ';path=/;domain=' + cphCookieDomain;
    };

    cphGlobal.getCookie = function(name) {
        function escape(s) {
            return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1');
        }

        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    };

    cphGlobal.getCookieByName = function(name) {
        // alias for legacy purposes
        return cphGlobal.getCookie(name);
    };

    cphGlobal.deleteCookie = function(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=' + cphCookieDomain;
    };

    cphGlobal.getEmail = function() {
        return cphGlobal.getCookieByName('auth_email') || cphGlobal.getCookieByName(cphPubAbbrev + '_email') || cphGlobal.getCookieByName('nl_email');
    };

    cphGlobal.isSubscriber = function() {
        return cphGlobal.getCookieByName('IsSubscriber') === 'True';
    };

    cphGlobal.isLoggedIn = function() {
        return cphGlobal.getCookieByName('IsLoggedIn') === 'True';
    };

    cphGlobal.isBetweenDates = function(startDate, endDate) {
        var date_switch_on = new Date(startDate),
            date_switch_off = endDate ? new Date(endDate) : false,
            date_now = new Date(),
            time_switch_on = date_switch_on.getTime(),
            time_switch_off = date_switch_off ? date_switch_off.getTime() : false,
            time_now = date_now.getTime();

        return (time_switch_off && time_now > time_switch_on && time_now < time_switch_off) || (!time_switch_off && time_now > time_switch_on);
    };

    cphGlobal.addUTM = function(url, source, medium, campaign, content) {
        if(source)
            url = cphGlobal.updateQueryStringParameter('utm_source', encodeURIComponent(source), url);
        if(medium)
            url = cphGlobal.updateQueryStringParameter('utm_medium', encodeURIComponent(medium), url);
        if(campaign)
            url = cphGlobal.updateQueryStringParameter('utm_campaign', encodeURIComponent(campaign), url);
        if(content)
            url = cphGlobal.updateQueryStringParameter('utm_content', encodeURIComponent(content), url);

        return url;
    };

    cphGlobal.removeUTM = function(url) {
        url = cphGlobal.updateQueryStringParameter('utm_source', false, url);
        url = cphGlobal.updateQueryStringParameter('utm_medium', false, url);
        url = cphGlobal.updateQueryStringParameter('utm_campaign', false, url);
        url = cphGlobal.updateQueryStringParameter('utm_content', false, url);
        url = cphGlobal.updateQueryStringParameter('utm_email', false, url);

        return url;
    };

    cphGlobal.toSlug = function(str) {
        return str.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/(\-)+/g, '-').replace(/^(\-)+/g, '').replace(/(\-)+$/g, '');
    };

    cphGlobal.toSnakeCase = function(str) {
        str = cphGlobal.toSlug(str);
        return str.replace(/(\-)+/g, '_');
    };

    cphGlobal.toCamelCase = function(str) {
        str = cphGlobal.toSlug(str);
        return str.replace(/(\-[a-z0-9])/g, function($1) {
            return $1.toUpperCase().replace('-', '');
        });
    };

    // @formatter:off
	cphGlobal.md5 = function(n){function r(n,r){var t=n[0],f=n[1],i=n[2],a=n[3];f=c(f=c(f=c(f=c(f=e(f=e(f=e(f=e(f=o(f=o(f=o(f=o(f=u(f=u(f=u(f=u(f,i=u(i,a=u(a,t=u(t,f,i,a,r[0],7,-680876936),f,i,r[1],12,-389564586),t,f,r[2],17,606105819),a,t,r[3],22,-1044525330),i=u(i,a=u(a,t=u(t,f,i,a,r[4],7,-176418897),f,i,r[5],12,1200080426),t,f,r[6],17,-1473231341),a,t,r[7],22,-45705983),i=u(i,a=u(a,t=u(t,f,i,a,r[8],7,1770035416),f,i,r[9],12,-1958414417),t,f,r[10],17,-42063),a,t,r[11],22,-1990404162),i=u(i,a=u(a,t=u(t,f,i,a,r[12],7,1804603682),f,i,r[13],12,-40341101),t,f,r[14],17,-1502002290),a,t,r[15],22,1236535329),i=o(i,a=o(a,t=o(t,f,i,a,r[1],5,-165796510),f,i,r[6],9,-1069501632),t,f,r[11],14,643717713),a,t,r[0],20,-373897302),i=o(i,a=o(a,t=o(t,f,i,a,r[5],5,-701558691),f,i,r[10],9,38016083),t,f,r[15],14,-660478335),a,t,r[4],20,-405537848),i=o(i,a=o(a,t=o(t,f,i,a,r[9],5,568446438),f,i,r[14],9,-1019803690),t,f,r[3],14,-187363961),a,t,r[8],20,1163531501),i=o(i,a=o(a,t=o(t,f,i,a,r[13],5,-1444681467),f,i,r[2],9,-51403784),t,f,r[7],14,1735328473),a,t,r[12],20,-1926607734),i=e(i,a=e(a,t=e(t,f,i,a,r[5],4,-378558),f,i,r[8],11,-2022574463),t,f,r[11],16,1839030562),a,t,r[14],23,-35309556),i=e(i,a=e(a,t=e(t,f,i,a,r[1],4,-1530992060),f,i,r[4],11,1272893353),t,f,r[7],16,-155497632),a,t,r[10],23,-1094730640),i=e(i,a=e(a,t=e(t,f,i,a,r[13],4,681279174),f,i,r[0],11,-358537222),t,f,r[3],16,-722521979),a,t,r[6],23,76029189),i=e(i,a=e(a,t=e(t,f,i,a,r[9],4,-640364487),f,i,r[12],11,-421815835),t,f,r[15],16,530742520),a,t,r[2],23,-995338651),i=c(i,a=c(a,t=c(t,f,i,a,r[0],6,-198630844),f,i,r[7],10,1126891415),t,f,r[14],15,-1416354905),a,t,r[5],21,-57434055),i=c(i,a=c(a,t=c(t,f,i,a,r[12],6,1700485571),f,i,r[3],10,-1894986606),t,f,r[10],15,-1051523),a,t,r[1],21,-2054922799),i=c(i,a=c(a,t=c(t,f,i,a,r[8],6,1873313359),f,i,r[15],10,-30611744),t,f,r[6],15,-1560198380),a,t,r[13],21,1309151649),i=c(i,a=c(a,t=c(t,f,i,a,r[4],6,-145523070),f,i,r[11],10,-1120210379),t,f,r[2],15,718787259),a,t,r[9],21,-343485551),n[0]=d(t,n[0]),n[1]=d(f,n[1]),n[2]=d(i,n[2]),n[3]=d(a,n[3])}function t(n,r,t,u,o,e){return r=d(d(r,n),d(u,e)),d(r<<o|r>>>32-o,t)}function u(n,r,u,o,e,c,f){return t(r&u|~r&o,n,r,e,c,f)}function o(n,r,u,o,e,c,f){return t(r&o|u&~o,n,r,e,c,f)}function e(n,r,u,o,e,c,f){return t(r^u^o,n,r,e,c,f)}function c(n,r,u,o,e,c,f){return t(u^(r|~o),n,r,e,c,f)}function f(n){var r,t=[];for(r=0;r<64;r+=4)t[r>>2]=n.charCodeAt(r)+(n.charCodeAt(r+1)<<8)+(n.charCodeAt(r+2)<<16)+(n.charCodeAt(r+3)<<24);return t}var i="0123456789abcdef".split("");function a(n){for(var r="",t=0;t<4;t++)r+=i[n>>8*t+4&15]+i[n>>8*t&15];return r}function h(n){return function(n){for(var r=0;r<n.length;r++)n[r]=a(n[r]);return n.join("")}(function(n){txt="";var t,u=n.length,o=[1732584193,-271733879,-1732584194,271733878];for(t=64;t<=n.length;t+=64)r(o,f(n.substring(t-64,t)));n=n.substring(t-64);var e=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(t=0;t<n.length;t++)e[t>>2]|=n.charCodeAt(t)<<(t%4<<3);if(e[t>>2]|=128<<(t%4<<3),t>55)for(r(o,e),t=0;t<16;t++)e[t]=0;return e[14]=8*u,r(o,e),o}(n))}function d(n,r){return n+r&4294967295}if("5d41402abc4b2a76b9719d911017c592"!=h("hello"))function d(n,r){var t=(65535&n)+(65535&r);return(n>>16)+(r>>16)+(t>>16)<<16|65535&t}return h(n)};
	// @formatter:on
})(jQuery);

var cphLoader = window.cphLoader || {};
(function($) {
    var scriptBeingLoaded = [], scriptIsLoaded = [];

    cphLoader.checkIfScriptLoaded = function(name, src, callback, firstLoadCallback) {
        scriptBeingLoaded[name] = (scriptBeingLoaded[name] === 'undefined') ? null : scriptBeingLoaded[name];
        scriptIsLoaded[name] = (scriptIsLoaded[name] === 'undefined') ? null : scriptIsLoaded[name];

        if(scriptBeingLoaded[name] && !scriptIsLoaded[name]) {
            setTimeout(function() {
                cphLoader.checkIfScriptLoaded(name, src, callback);
            }, 250);
        } else {
            scriptBeingLoaded[name] = true;
            var methods = name.split('.'),
                functionName = window;

            for(var i in methods) {
                functionName = functionName[methods[i]];
            }

            if(typeof functionName === 'undefined') {
                var getScript = $.ajax({
                    type    : 'GET',
                    url     : src,
                    dataType: 'script',
                    cache   : true
                });

                getScript.done(function(script, textStatus, jqxhr) {
                    console.log(name + ' loaded');
                    if(jqxhr.status < 400) {
                        if(typeof firstLoadCallback === 'function') {
                            firstLoadCallback.call(this);
                        }
                        if(typeof callback === 'function') {
                            scriptIsLoaded[name] = true;
                            callback.call(this);
                        }
                    }
                });

                getScript.always(function() {
                    scriptBeingLoaded[name] = false;
                });
            } else {
                if(typeof callback === 'function') {
                    callback.call(this);
                }
            }
        }
    };

    cphLoader.checkIfStyleLoaded = function(id, src) {
        if(!$('#' + id).length) {
            $('<link/>', {
                id  : id,
                rel : 'stylesheet',
                type: 'text/css',
                href: src
            }).appendTo('head');
        }
    };

    cphLoader.loadSwiper = function(callback) {
        cphLoader.checkIfStyleLoaded('swiper-css', 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/6.8.4/swiper-bundle.min.css');
        cphLoader.checkIfScriptLoaded('Swiper', 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/6.8.4/swiper-bundle.min.js', callback);
    };

    cphLoader.loadTableSorter = function(callback) {
        $(function() {
            // https://mottie.github.io/tablesorter/docs/index.html
            cphLoader.checkIfStyleLoaded('tablesorter-css', 'https://cdnjs.cloudflare.com/ajax/libs/jquery.tablesorter/2.31.3/css/theme.default.min.css');
            cphLoader.checkIfScriptLoaded('jQuery.fn.tablesorter', 'https://cdnjs.cloudflare.com/ajax/libs/jquery.tablesorter/2.31.3/js/jquery.tablesorter.combined.min.js', callback);
        });
    };

    cphLoader.loadLazySizes = function(callback) {
        cphLoader.checkIfScriptLoaded('lazySizes', 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/4.0.1/lazysizes.min.js', callback);
    };

    cphLoader.loadThrottleDebounce = function(callback) {
        //no longer making external call for this script. Now at top of base.js
        //cphLoader.checkIfScriptLoaded("jQuery.throttle", "https://cdnjs.cloudflare.com/ajax/libs/jquery-throttle-debounce/1.1/jquery.ba-throttle-debounce.js", callback);
        if(typeof callback === 'function') {
            callback.call(this);
        }
    };

    cphLoader.loadFlatpickr = function(callback, rangePlugin, theme) {
        if(!rangePlugin) rangePlugin = false;
        if(!theme) theme = 'airbnb'; // airbnb, confetti, dark, light, material_blue, material_green, material_orange, material_red
        cphLoader.checkIfStyleLoaded('flatpickr-css', '//cdnjs.cloudflare.com/ajax/libs/flatpickr/4.5.2/flatpickr.min.css');
        cphLoader.checkIfStyleLoaded('flatpickr-theme-' + theme + '-css', '//cdnjs.cloudflare.com/ajax/libs/flatpickr/4.5.2/themes/' + theme + '.css');
        cphLoader.checkIfScriptLoaded('flatpickr', '//cdnjs.cloudflare.com/ajax/libs/flatpickr/4.5.2/flatpickr.min.js', function() {
            if(rangePlugin) {
                cphLoader.checkIfScriptLoaded('rangePlugin', '//cdnjs.cloudflare.com/ajax/libs/flatpickr/4.5.2/plugins/rangePlugin.js', callback);
            }
        });
    };

    cphLoader.loadSoundcite = function(callback) {
        cphLoader.checkIfStyleLoaded('soundcite-css', 'https://cdn.knightlab.com/libs/soundcite/latest/css/player.css');
        cphLoader.checkIfScriptLoaded('soundciteLoader', 'https://cdn.knightlab.com/libs/soundcite/latest/js/soundcite.min.js', callback);
        window.soundciteLoader = true; // because the script does not use a globally scoped function, I can't tell if it has been loaded.
    };

    cphLoader.loadTipped = function(callback) {
        cphLoader.checkIfStyleLoaded('tipped-css', 'https://cdn.pressdemocrat.com/vendor/tipped/4.7.0/tipped.css');
        cphLoader.checkIfScriptLoaded('Tipped', 'https://cdn.pressdemocrat.com/vendor/tipped/4.7.0/tipped.js', callback);
    };

    cphLoader.loadPdfObject = function(callback) {
        cphLoader.checkIfScriptLoaded('PDFObject', '//cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.js', callback);
    };

    cphLoader.loadCphLightbox = function(callback) {
        //cphLoader.checkIfScriptLoaded("cphLightbox", "https://code.pressdemocrat.com/shared/2020/vendor/cph/lightbox/3.0.2/lightbox.min.js", callback);
        cphLoader.checkIfScriptLoaded('cphLightbox', 'https://cdn.pressdemocrat.com/vendor/cph/lightbox/3.0.4/lightbox.min.js', callback);
    };

    cphLoader.loadCphGallery = function(callback) {
        cphLoader.loadSwiper(function() {
            //cphLoader.checkIfScriptLoaded("cphGallery", "https://code.pressdemocrat.com/shared/2020/vendor/cph/gallery/1.0.0/gallery.min.js", callback);
            cphLoader.checkIfScriptLoaded('cphGallery', 'https://cdn.pressdemocrat.com/vendor/cph/gallery/1.0.1/gallery.min.js', callback);
        });
    };

    cphLoader.loadSortable = function(callback) {
        cphLoader.checkIfScriptLoaded('Sortable', 'https://cdnjs.cloudflare.com/ajax/libs/Sortable/1.13.0/Sortable.min.js', callback);
    };
})(jQuery);
const ga4Tags = {};
ga4Tags['smi'] = 'G-84Q5ST7BN6';
ga4Tags['site'] = null;
ga4Tags['paywall'] = null;

switch(cphPubAbbrev) {
    case 'pd' :
        ga4Tags['site'] = 'G-1V71J0RS5C';
        ga4Tags['paywall'] = 'G-Q3RYZ35K41';
        break;
    case 'sit' :
        ga4Tags['site'] = 'G-K5E335ZW0Z';
        ga4Tags['paywall'] = 'G-K2KZ2GWN99';
        break;
    case 'pac' :
        ga4Tags['site'] = 'G-80KN4D1J3G';
        ga4Tags['paywall'] = 'G-9V23XZQZFC';
        break;
    case 'nbbj' :
        ga4Tags['site'] = 'G-F5RJL13SPW';
        break;
    case 'scg' :
        ga4Tags['site'] = 'G-9NTV5449WZ';
        break;
    case 'lps' :
        ga4Tags['site'] = 'G-TCR7Z2E57D';
        break;
}

window.dataLayer = window.dataLayer || [];

if(ga4Tags.site) {
    (function() {
        const head = document.getElementsByTagName('head')[0];
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + ga4Tags.site;
        head.appendChild(script);
    })();

    function gtag() {dataLayer.push(arguments);}

    gtag('js', new Date());

    gtag('config', ga4Tags.site, {
        'groups'        : 'always',
        'send_page_view': false
    });

    if(ga4Tags.smi) {
        gtag('config', ga4Tags.smi, {
            'groups'        : 'always',
            'send_page_view': false
        });
    }

    if(ga4Tags.paywall) {
        gtag('config', ga4Tags.paywall, {
            'groups'        : 'paywall',
            'send_page_view': false
        });
    }
}

jQuery(function($) {
    const ga4Type = window.pageType || '';
    const ga4Sections = window.pageSections || [];
    const ga4Topics = window.pageTags || [];
    const ga4Mg2PageData = window.mg2PageData || {};

    gtag('event', 'page_view', {
        'sections'     : ga4Sections,
        'topics'       : ga4Topics,
        'page_type'    : ga4Type,
        'is_metered'   : ga4Mg2PageData.metered || 0,
        'is_premium'   : ga4Mg2PageData.premium || 0,
        'is_subscribed': cphGlobal.isSubscriber(),
        'is_logged_in' : cphGlobal.isLoggedIn(),
        'send_to'      : 'always'
    });

    ga4Sections.forEach(function(section) {
        gtag('event', 'section', {
            'section_name': section,
            'send_to'     : 'always'
        });
    });

    ga4Topics.forEach(function(topic) {
        gtag('event', 'topic', {
            'topic_name': topic,
            'send_to'   : 'always'
        });
    });

    $(document).on('smi:gallerySlide', function() {
        const slideNum = parseInt(cphGlobal.getQueryStringValueByKey('artslide') || -1) + 1;
        gtag('event', 'page_view', {
            'gallery_slide'    : true,
            'gallery_slide_num': slideNum,
            'send_to'          : 'always'
        });

        gtag('event', 'gallery', {
            'gallery_slide'    : true,
            'gallery_slide_num': slideNum,
            'send_to'          : 'always'
        });

        ga4Sections.forEach(function(section) {
            gtag('event', 'section', {
                'section_name' : section,
                'gallery_slide': true,
                'send_to'      : 'always'
            });
        });

        ga4Topics.forEach(function(topic) {
            gtag('event', 'topic', {
                'topic_name'   : topic,
                'gallery_slide': true,
                'send_to'      : 'always'
            });
        });
    });

    $(document).on('smi:paywallShown', function() {
        if(ga4Tags.paywall) {
            gtag('event', 'page_view', {
                'paywall_shown': true,
                'is_premium'   : ga4Mg2PageData.premium || 0,
                'send_to'      : 'paywall'
            });
        }

        gtag('event', 'paywall', {
            'paywall_shown': true,
            'is_premium'   : ga4Mg2PageData.premium || 0,
            'send_to'      : 'always'
        });
    });

    $(document).on('smi:ajaxPageView', function() {
        gtag('event', 'page_view', {
            'is_ajax': true,
            'send_to': 'always'
        });
    });

    $(document).on('onLoginSuccess', function(e) {
        // onLoginSuccess event fired by Engage (MG2)
        gtag('event', 'login', {
            'method' : e.originalEvent.detail.AuthSystem || '',
            'send_to': 'always'
        });
    });

    $('#search-page-form, .search-form').on('submit', function() {
        const form = $(this);
        let query = form.find('input[name="q"]').val();
        if(query) {
            gtag('event', 'search', {
                'search_term': query,
                'send_to'    : 'always'
            });
        }
    });

    $('.share-icons__icon').on('click', function() {
        const icon = $(this);
        let network = icon.data('network');
        if(network) {
            gtag('event', 'share', {
                'method'      : network,
                'content_type': 'article',
                'item_id'     : window.articleUuid
            });
        }
    });
});

(function($) {
    $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    $.fn.isFocusable = function() {
        return $(this).not('[tabindex=-1], [disabled], :hidden').is('a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]');
    }
})(jQuery);
jQuery(function($) {
    $(document).on('dfpRendered', function(e, adSlot, origEvent) {
        if($(adSlot).closest('.pw-adhesion-wrap').length) {
            $('#pw-adhesion-button-wrap').remove();
            if(origEvent.isEmpty)
                return;

            setTimeout(function() {
                // display the pw-adhesion-close button (x) &#215;
                var close = $('<div id="pw-adhesion-button-wrap"><span id="pw-adhesion-button-close" title="Close Ad">&#215;</span></div>');

                var adIframe = $('.pw-adhesion-wrap iframe:first:visible');
                adIframe.before(close);
                var width = adIframe.attr('width');

                $('#pw-adhesion-button-wrap').css('max-width', width + 'px');

                $('#pw-adhesion-button-wrap span').click(function() {
                    $('.pw-adhesion-wrap').slideToggle('slow');
                });
            }, 15000);
        }
    });
});

/*jQuery(function($) {
    $('body').append('<div class="s2nPlayer k-atlpCxHi" data-type="float"></div><script type="text/javascript" src="//embed.sendtonews.com/player3/embedcode.js?fk=atlpCxHi&cid=5649&offsetx=0&offsety=0&floatwidth=400&floatposition=bottom-right" data-type="s2nScript"></script>');
});*/

if(cphPD || cphSIT || cphPAC) {
    jQuery(function() {
        // RETARGETING PIXEL: TC: 2024-02-01: PD-Visitor – this will add anyone who reads an article to the Visitor Pool. Should be placed on all pages.
        $.getScript('https://cdn01.basis.net/assets/up.js?um=1', function() {
            cntrUpTag.track('cntrData', '799b66c6271a231b');
        });

        // RETARGETING PIXEL: TC: 2024-02-05: PD-Subscriber – this will create the subscriber pool – this will fire when someone is logged in.
        $(document).on('mg2:subscribed', function() {
            $.getScript('https://cdn01.basis.net/assets/up.js?um=1', function() {
                cntrUpTag.track('cntrData', 'a10e4924bfcbdc17');
            });
        });
    });
}

/*jQuery(function($) {
    var menu = $('#menu-contact-help');
    if(!menu.length) return;

    var cookiePrefs = $('<li><a href="javascript:void(0);">Cookie Preferences</a></li>'),
        doNotSell = $('<li><a href="#">Do Not Sell My Personal Info</a></li>'),
        privacyUrl = siteConfig.url.privacy || false;

    menu.append(cookiePrefs);

    cookiePrefs.find('a').on('click', function() {
        $(document).trigger('loadCCPAwindow');
    });

    if(privacyUrl) {
        doNotSell.find('a').attr('href', privacyUrl + '/policy/#do-not-sell');
        menu.append(doNotSell);
    }
});*/

// OVERWRITE PD PLUS ICON WITH VERSION THAT HAS TOOLTIP
jQuery(function($) {
    var plusIcon = $('<span/>', {
        class: 'tier-icon',
        title: 'Premium content, available to subscribers only.'
    });

    var breakingFreeIcon = $('<span/>', {
        class: 'tier-icon',
        title: 'Essential news for the community - free from the ' + cphPubName + '.'
    });

    var hasVideoIcon = $('<span/>', {
        class: 'tier-icon no-tooltip'
    });

    $(document).on('tpl:blockLoaded', function(e, block) {
        block = $(block);

        var tierIcons = block.find('[data-tier="plus"], [data-tier="breaking-free"], [data-tier="has-video"]').find('.story-heading h3, .tpl2022__headline h3');

        tierIcons.each(function() {
            var headline = $(this);
            if(!headline.hasClass('has-tier-icon')) {
                if(headline.closest('[data-tier="plus"]').length) {
                    headline.find('.tier-icon').remove();
                    headline.prepend(plusIcon.clone());
                    loadTippedDeferred();
                } else if(headline.closest('[data-tier="breaking-free"]').length) {
                    headline.find('.tier-icon').remove();
                    headline.prepend(breakingFreeIcon.clone());
                    loadTippedDeferred();
                } else if(headline.closest('[data-tier="has-video"]').length) {
                    headline.find('.tier-icon').remove();
                    headline.prepend(hasVideoIcon.clone());
                    loadTippedDeferred();
                }

                // always add .has-tier-icon class so it stops trying
                headline.addClass('has-tier-icon');
            }
        });
    });

    $('a[href*="/premium/"]').each(function() {
        const link = $(this);

        try {
            const path = new URL(link.attr('href'), 'https://' + cphHost).pathname || '';

            if(link.closest('[data-tier="plus"]').length) return;
            if(link.find('> img').length) return;

            if(path.startsWith('/premium') || path.startsWith('/article/premium')) {
                if(!link.hasClass('has-tier-icon')) {
                    link.prepend(plusIcon.clone()).attr('data-tier', 'plus').addClass('has-tier-icon');
                    loadTippedDeferred();
                }
            }
        } catch {
            // fail silently
        }
    });

    var tippedDeferredLoaded = false;

    function loadTippedDeferred() {
        if(!tippedDeferredLoaded) {
            tippedDeferredLoaded = true;
            cphLoader.loadTipped(function() {
                Tipped.delegate('.tier-icon:not(".no-tooltip")', {
                    position: 'topleft',
                    offset  : {
                        y: -5
                    },
                    behavior: 'hide',
                    maxWidth: 250,
                    size    : 'large'
                });
            });
        }
    }
});

jQuery(function($) {
    let menu = $('.main-menu__container');

    // scroll to top when top-level menu items focused
    menu.find('> ul > li > a').on('focusin', function() {
        window.scrollTo(0, 0);
    });

    // create submenu within tooltip on click or hover
    cphLoader.loadTipped(function() {
        menu.find('> ul > li > ul').each(function() {
            let submenu = $(this),
                parent = submenu.closest('li'),
                link = parent.find('a').first();

            link.attr('aria-expanded', 'false');

            submenu.attr('tabindex', '-1');

            const tipped = Tipped.create(link, submenu, {
                container         : $('.main-menu'),
                position          : 'topright',
                maxWidth          : 250,
                skin              : 'light',
                size              : 'large',
                stem              : true,
                padding           : false,
                radius            : false,
                offset            : {y: 10},
                showOn            : {
                    element: 'mouseenter',
                    tooltip: 'mouseenter'
                },
                hideOn            : {
                    element: 'mouseleave',
                    tooltip: 'mouseleave'
                },
                hideOnClickOutside: true,
                hideOthers        : true,
                voila             : false,
                zIndex            : 9,
                onShow            : function() {
                    link.attr('aria-expanded', 'true');
                },
                afterHide         : function() {
                    link.attr('aria-expanded', 'false');
                }
            });

            link.on('click', function(e) {
                e.preventDefault();
                tipped.show();

                submenu.off('focusout');
                submenu.on('focusout', function() {
                    setTimeout(function() {
                        if(!$(document.activeElement).closest(submenu).length) {
                            tipped.hide();
                            link.focus();
                        }
                    });
                });

                setTimeout(function() {
                    submenu.focus();
                });
            });

/*
            link.on('mouseenter click', function(e) {
                e.preventDefault();
                Tipped.hideAll();
                let tipped = Tipped.get(link);
                if(tipped.tooltips.length) {
                    setTimeout(function() {
                        tipped.show();
                        if(e.type === 'click') {
                            submenu.focus();
                        }
                    });
                    return;
                }

                tipped = Tipped.create(link, submenu, {
                    container: $('.main-menu__container')[0],
                    position: 'topright',
                    maxWidth: 250,
                    skin: 'light',
                    size: 'large',
                    stem: true,
                    padding: false,
                    radius: false,
                    offset: {y: 5},
                    showOn: {
                        element: 'mouseenter',
                        tooltip: 'mouseenter'
                    },
                    hideOn: {
                        element: 'mouseleave',
                        tooltip: 'mouseleave'
                    },
                    hideOnClickOutside: true,
                    hideOthers: true,
                    voila: false,
                    zIndex: 9,
                    onShow: function() {
                        link.attr('aria-expanded', 'true');
                    },
                    afterHide: function() {
                        link.attr('aria-expanded', 'false');
                    }
                }).show();

                if(e.type === 'click') {
                    setTimeout(function() {
                        submenu.focus();
                    });
                }

                submenu.on('focusout', function() {
                    setTimeout(function() {
                        if(!$.contains(submenu[0], document.activeElement)) {
                            tipped.hide();
                            link.focus();
                        }
                    });
                });
            });
*/
        });
    });
});
jQuery(function($) {
    let toggle = $('#ttt-search-toggle'),
        openIcon = $('#ttt-search-toggle-open'),
        closeIcon = $('#ttt-search-toggle-close'),
        form = $('#ttt-header-search-form');

    let closeSearch = function() {
        if(toggle.is('[aria-expanded="true"]')) {
            $(document).add(form).off('.headerSearchBox');
            closeIcon.addClass('hide');
            openIcon.removeClass('hide');
            form.removeClass('show');
            toggle.attr('aria-expanded', 'false');
            toggle.focus();
        }
    };

    toggle.on('click', function() {
        if(toggle.is('[aria-expanded="true"]')) {
            closeSearch();
        } else {
            openIcon.addClass('hide');
            closeIcon.removeClass('hide');
            form.addClass('show');
            toggle.attr('aria-expanded', 'true');
            form.find('input').focus();

            form.on('focusout.headerSearchBox', function(e) {
                if(!$(e.relatedTarget).is(toggle)) {
                    setTimeout(function() {
                        if(!$.contains(form[0], document.activeElement)) {
                            closeSearch();
                        }
                    });
                }
            });

            $(document).on('keydown.headerSearchBox', function(e) {
                if(e.key === 'Escape') {
                    closeSearch();
                }
            });
        }
    });
});
jQuery(function($) {
    let toggles = $('.header__submenu-toggle');
    toggles.on('click', function(e) {
        let toggle = $(this),
            isExpanded = toggle.is('[aria-expanded="true"]'),
            parent = toggle.closest('li');

        e.preventDefault();

        if(isExpanded) {
            toggle.attr('aria-expanded', 'false');
            parent.removeClass('expanded');
            $(document).off('click.headerSubmenu');
        } else {
            let closeSubmenu = function(focusToggle) {
                toggle.attr('aria-expanded', 'false');
                parent.removeClass('expanded');
                $(document).add(parent).off('.headerSubmenu');
                if(focusToggle) toggle.focus();
            }

            toggle.attr('aria-expanded', 'true');
            parent.addClass('expanded');

            $(document).add(parent).off('.headerSubmenu');

            parent.on('focusout.headerSubmenu', function(e) {
                if(!$(e.relatedTarget).is(toggle)) {
                    setTimeout(function() {
                        if(!$.contains(parent[0], document.activeElement)) {
                            closeSubmenu();
                        }
                    });
                }
            });

            $(document).on('keydown.headerSubmenu', function(e) {
                if(e.key === 'Escape') {
                    closeSubmenu(true);
                }
            });

            $(document).on('click.headerSubmenu', function(e) {
                if($(e.target).closest(parent).length === 0) {
                    closeSubmenu(true);
                }
            });
        }
    });
});
jQuery(function($) {
    $(window).on('scroll lazyload', $.throttle(350, function() {
        $('.lazyload[data-src]').not('.loading, .loaded').each(function() {
            var image = $(this);
            if(isAboveBottomOfViewport(image)) {
                var src = image.data('src'),
                    srcset = image.data('srcset'),
                    sizes = image.data('sizes');

                image.removeAttr('data-src').removeAttr('data-srcset').removeAttr('data-sizes').addClass('loading').css({
                    opacity   : 0,
                    transition: 'opacity 180ms'
                });
                image.on('load', function() {
                    image.removeClass('lazyload loading').addClass('loaded').css({opacity: 1});
                });
                image.attr('src', src).attr('srcset', srcset).attr('sizes', sizes);
            }
        });
    }));

    $(window).trigger('lazyload');

    function isAboveBottomOfViewport(el) {
        el = (typeof el === 'string' || el instanceof String) ? $(el) : el;
        var elementTop = el.offset().top,
            viewportTop = $(window).scrollTop(),
            viewportBottom = viewportTop + $(window).height();
        return elementTop < viewportBottom;
    }
});
// MG2 AUTHENTICATION, PAYWALL AND NEWSLETTER HANDLERS
// https://github.com/mg2connext/connext/wiki/dev

jQuery(function($) {
    var debug = cphGlobal.getQueryStringValueByKey('mg2Debug') === '1';

    if(debug) {
        console.log('MG2: auth_type:', cphGlobal.getCookieByName('auth_type'));
        console.log('MG2: is_internal:', isInternal());
    }

    var pathname = location.pathname.replace(/^\//, '').replace(/\/$/, '');
    if(pathname === 'auth-redirect') return;

    var body = $(document.body),
        loginButton = $('#mg2-login-button'),
        registerButton = $('#mg2-register-button'),
        accountMenu = $('#mg2-account-menu'),
        accountGravatar = $('#mg2-account-gravatar'),
        emailHeading = $('#mg2-email-heading'),
        logoutButton = $('#mg2-logout'),

        loggedOutMenu = $('#MG2logged-out-menu'), // remove later
        activateMenu = $('#MG2activate-menu'), // remove later
        loggedInMenu = $('#MG2logged-in-menu'), // remove later

        internalEmail = 'info@' + cphDomain;

    function setEmail(email) {
        email = (email || '').toString().toLowerCase().trim();
        cphGlobal.setCookie('auth_email', email, 30);
        cphGlobal.setCookie(cphPubAbbrev + '_email', email, 30);
    }

    function isLoggedIn() {
        return cphGlobal.getCookieByName('IsLoggedIn') === 'True';
    }

    function setLoggedIn() {
        if(!isLoggedIn()) {
            // check if exists first to keep it a 30-day cookie
            cphGlobal.setCookie('IsLoggedIn', 'True', 30);
        }
    }

    function deleteLoggedIn() {
        cphGlobal.deleteCookie('IsLoggedIn');
    }

    function isSubscriber() {
        return cphGlobal.getCookieByName('IsSubscriber') === 'True';
    }

    function setIsSubscriber() {
        if(!isSubscriber()) {
            // check if exists first to keep it a 30-day cookie
            cphGlobal.setCookie('IsSubscriber', 'True', 30);
        }
    }

    function deleteIsSubscriber() {
        cphGlobal.deleteCookie('IsSubscriber');
    }

    function getEmail() {
        return cphGlobal.getCookieByName('auth_email');
    }

    function deleteEmail() {
        cphGlobal.deleteCookie('auth_email');
        cphGlobal.deleteCookie(cphPubAbbrev + '_email');
        cphGlobal.deleteCookie('nl_email');
    }

    function isInternal() {
        return cphGlobal.getCookieByName('auth_type') === 'internal';
    }

    function setAuthTypeUser() {
        cphGlobal.setCookie('auth_type', 'user');
    }

    function setAuthTypeInternal() {
        cphGlobal.setCookie('auth_type', 'internal');
    }

    function hasAuthType() {
        return cphGlobal.cookiesEnabled() && cphGlobal.getCookieByName('auth_type');
    }

    function deleteAuthType() {
        cphGlobal.deleteCookie('auth_type');
    }

    function setNewsletterEmailCookie(email) {
        if(email || !cphGlobal.getCookieByName('nl_email')) {
            email = email || getEmail();
            if(email) cphGlobal.setCookie('nl_email', email, 365);
        }
    }

    function getUserData() {
        if(window.Connext) {
            if(typeof Connext.Storage.GetUserData === 'function') {
                return Connext.Storage.GetUserData();
            }
        }
        return {};
    }

    function isMg2() {
        var userData = getUserData();
        return typeof userData.AuthSystem === 'string' && userData.AuthSystem === 'MG2';
    }

    function isAuth0() {
        var userData = getUserData();
        return typeof userData.AuthSystem === 'string' && userData.AuthSystem === 'Auth0UniversalLogin';
    }

    function setBodyAuthStatus(authStatus) {
        body.removeClass('circ-subscribed circ-logged-in circ-logged-out');
        body.addClass('circ-' + authStatus);
    }

    function addPaywallBlur() {
        $('.pw-section:not(:first) > *, .pw-section:first > *:not(.mark-text)').not('.do-not-blur').addClass('blurry-text');

        $('.pw-section .pd-shortcode-widget, .main-gallery, .related-stories, .related-stories-bs').not('.do-not-blur').addClass('pw-blur');

        $('.fact-box, .hide-on-paywall, .trinity-audio-widget').addClass('pw-hide');

        body.addClass('has-pw circ-paywall');
    }

    function removePaywallBlur() {
        $('.blurry-text, .pw-blur, .pw-hide, .has-pwb').removeClass('blurry-text pw-blur pw-hide');
        body.removeClass('has-pw circ-paywall');
    }

    function doLoggedIn() {
        var userData = getUserData();
        if(typeof userData.Email === 'string') {
            var newEmail = userData.Email.toLowerCase().trim(),
                storedEmail = getEmail();

            if(newEmail && newEmail !== storedEmail) {
                setEmail(newEmail);
                setNewsletterEmailCookie();
            }
        }

        var authEmail = getEmail();
        if(isInternal() && authEmail !== internalEmail) {
            setAuthTypeUser();
        }

        setLoggedIn();

        if(authEmail && authEmail.length) {
            emailHeading.text(authEmail);
            emailHeading.removeClass('hide');
            accountGravatar.attr('src', 'https://www.gravatar.com/avatar/' + cphGlobal.md5(authEmail) + '?s=50&d=mp');
        } else {
            emailHeading.addClass('hide');
            accountGravatar.attr('src', 'https://secure.gravatar.com/avatar/?s=50&d=mp');
        }

        logoutButton.off('click').one('click', function(e) {
            e.preventDefault();

            if(debug) {
                console.log('MG2: LO: auth_type:', cphGlobal.getCookieByName('auth_type'));
                console.log('MG2: LO: is_internal:', isInternal());
            }

            if(isInternal()) {
                setAuthTypeUser();
                if(debug) console.log('MG2:', 'Switching \'auth_type\' to \'user\' to prevent internal login.');
            } else {
                deleteAuthType();
                if(debug) console.log('MG2:', 'Deleting \'auth_type\' to reset on next pageload.');
            }

            doNotSubscribed();

            setTimeout(function() {
                if(debug) console.log('MG2: auth_type:', cphGlobal.getCookieByName('auth_type'));

                Connext.Logout();
                if(debug) console.log('MG2:', 'Logged out');
                $(document).trigger('mg2:loggedOut');
                if(isMg2()) Connext.Run();
            });
        });





        // remove later
        loggedInMenu.add(activateMenu).each(function() {
            var menu = $(this),
                ul = menu.find('ul').first(),
                heading = ul.find('li.mg2-email-heading'),
                logout = ul.find('.mg2-logout');

            if(authEmail && authEmail.length) {
                if(heading.length) {
                    heading.text(authEmail);
                } else {
                    $('<li/>', {
                        class: 'mg2-email-heading email-heading',
                        text : authEmail
                    }).prependTo(ul);
                }
            } else {
                heading.remove();
            }

            logout.off('click').one('click', function(e) {
                e.preventDefault();

                if(debug) {
                    console.log('MG2: LO: auth_type:', cphGlobal.getCookieByName('auth_type'));
                    console.log('MG2: LO: is_internal:', isInternal());
                }

                if(isInternal()) {
                    setAuthTypeUser();
                    if(debug) console.log('MG2:', 'Switching \'auth_type\' to \'user\' to prevent internal login.');
                } else {
                    deleteAuthType();
                    if(debug) console.log('MG2:', 'Deleting \'auth_type\' to reset on next pageload.');
                }

                doNotSubscribed();

                setTimeout(function() {
                    if(debug) console.log('MG2: auth_type:', cphGlobal.getCookieByName('auth_type'));

                    Connext.Logout();
                    if(debug) console.log('MG2:', 'Logged out');
                    $(document).trigger('mg2:loggedOut');
                    if(isMg2()) Connext.Run();
                });
            });
        });
    }





    function doSubscribed() {
        showMenuSubscribed();

        setBodyAuthStatus('subscribed');

        deleteLoggedIn();
        setIsSubscriber();

        var authEmail = getEmail();

        $(document).trigger('mg2:loggedIn', {email: authEmail});
        $(document).trigger('mg2:subscribed', {userData: getUserData()});

        // remove later
        $('#header-gravatar').attr('src', 'https://www.gravatar.com/avatar/' + cphGlobal.md5(authEmail) + '?s=50&d=mp');

        removePaywallBlur();
    }

    function doNotSubscribed(authStatus) {
        if(isInternal()) {
            setEmail(internalEmail);
            doLoggedIn();
            doSubscribed();
        } else {
            if(authStatus) {
                setBodyAuthStatus(authStatus);
                if(authStatus === 'logged-out') {
                    deleteLoggedIn();
                    deleteEmail();
                }
            }
            deleteIsSubscriber();

        }

        $(document).trigger('mg2:notSubscribed', {userData: getUserData()});
    }

    function doActivateLoopFix() {
        if(debug) console.log('MG2: checking for activation loop');

        if(window.Connext) {
            let settings = Connext.Storage.GetLocalConfiguration().Settings,
                siteCode = settings.Site.SiteCode,
                campaign = settings.Code,
                environment = cphGlobal.isProd() ? 'PROD' : 'STAGE',
                userData = Connext.Storage.GetUserData(),
                userState = Connext.Storage.GetUserState(),
                email = userData.Email;

            if(!siteCode || !campaign) return;

            if(email || userState !== 'Logged In') return;

            if(!cphGlobal.cookiesEnabled() || !cphGlobal.hasLocalStorage()) return;

            if(cphGlobal.getCookieByName('mg2_activate_loop_check')) return;

            cphGlobal.setCookie('mg2_activate_loop_check', '1');

            const keyName = 'connext_user_data_' + siteCode.toUpperCase() + '_' + campaign.toUpperCase() + '_' + environment;

            if(debug) console.log('MG2: *** possible activation loop found. Clearing ' + keyName + ' and refreshing');

            localStorage.removeItem(keyName);

            location.reload();
        }
    }

    $(document).on('onNewsletterSignUp', function(e) {
        try {
            var nlEmail = e.detail.EventData.Email.toLowerCase().trim();
            if(nlEmail) setNewsletterEmailCookie(nlEmail);
        } catch(e) {
            console.log('email not set by onNewsletterSignUp event');
        }
    });

    $(document).on('removePaywallBlur', function() {
        removePaywallBlur();
    });

    $(document).on('onPaywallShown', function(e) {
        $(document).trigger('smi:paywallShown');

        // remove MG2 styles that collapse/hide any embeds within article
        $('style.content-styles.mark-text').remove();

        addPaywallBlur();
    });

    /** MG2 AUTHENTICATION EVENTS
     *
     * onHasAccess                  Logged in and subscribed
     * onNotAuthorized              Logged out. Unknown subscription status
     *
     * onAuthorized                 Logged in, but never subscribed
     * onHasNoActiveSubscription    Logged in, but subscription expired
     * onHasAccessNotEntitled       Logged in, but no access to current content
     *
     * DOCUMENTATION
     * https://docs.navigaglobal.com/engage/-MGi9-KKLwnWfoD36Ot6/getting-started-with-engage/configuring-engage-on-your-website/configuring-the-access-buttons
     *
     * notable events - onAdblockFound, onNewsletterArrival, onAccessGranted
     */

    function showMenuLoggedOut() {
        loggedInMenu.addClass('hide'); // remove later
        activateMenu.addClass('hide'); // remove later
        loggedOutMenu.removeClass('hide'); // remove later

        loginButton.removeClass('hide');
        registerButton.addClass('hide');
        accountMenu.addClass('hide');
    }

    function showMenuLoggedIn() {
        loggedInMenu.addClass('hide'); // remove later
        loggedOutMenu.addClass('hide'); // remove later
        activateMenu.removeClass('hide'); // remove later

        loginButton.addClass('hide');
        registerButton.addClass('hide');
        accountMenu.removeClass('hide');
    }

    function showMenuSubscribed() {
        loggedOutMenu.addClass('hide'); // remove later
        activateMenu.addClass('hide'); // remove later
        loggedInMenu.removeClass('hide'); // remove later

        loginButton.addClass('hide');
        registerButton.addClass('hide');
        accountMenu.removeClass('hide');
    }

    // logged in and can access content
    $(document).on('onHasAccess', function(e) {
        showMenuSubscribed();
        doLoggedIn();
        doSubscribed();
    });

    // logged in, but can't access this content
    $(document).on('onHasAccessNotEntitled', function(e) {
        showMenuSubscribed();
        doLoggedIn();
        doNotSubscribed('logged-in');
    });

    // logged in, but no subscription
    $(document).on('onAuthorized onHasNoActiveSubscription', function(e) {
        showMenuLoggedIn();
        doLoggedIn();
        doNotSubscribed('logged-in');
        doActivateLoopFix();
    });

    // logged out
    $(document).on('onNotAuthorized', function(e) {
        showMenuLoggedOut();
        doNotSubscribed('logged-out');
    });

    // fired by inline script inside Naviga web
    $(document).on('mg2:loaded', function() {
        body.removeClass('circ-loaded circ-failed').addClass('circ-loaded');
    });

    $(document).on('mg2:failed', function() {
        body.removeClass('circ-loaded circ-failed').addClass('circ-failed');
    });

    if(!hasAuthType()) {
        setAuthTypeUser();
        var response = $.getJSON('https://api.pressdemocrat.com/utility/is-internal.php');
        response.done(function(data, textStatus, jqXHR) {
            if(jqXHR.status === 204) {
                setAuthTypeInternal();
            }
        });
    }

    setBodyAuthStatus('logged-out');

    if(isSubscriber()) {
        doLoggedIn();
        doSubscribed();
    }

    if(debug) {
        $(document).on('onAdblockFound onNewsletterArrival onRun onFinish onInit onDynamicMeterFound onMeterLevelSet onLoadError', function(e) {
            console.log('MG2:', e.type, e);
        });
    }
});
window.smiPromoOffer = 'none';

(function($) {
    // on MG2 init, check if ZIP Code is from napa and, if so, trigger mg2:isNapa event.
    $(document).on('onInit', function() {
        const napaZips = [/*'94503', */'94508', '94515', '94558', '94559', '94562', '94567', '94573', '94574', '94576', '94581', '94599'];
        const zipCodes = Connext.Storage.GetActualZipCodes();
        let isNapa = false,
            zipCode;

        if(zipCodes && zipCodes.length) {
            while(zipCode = zipCodes.shift()) {
                if(napaZips.indexOf(zipCode) !== -1) {
                    isNapa = true;
                    break;
                }
            }
        }

        if(isNapa) $(document).trigger('mg2:isNapa');
    });

    $(document).one('mg2:loaded mg2:failed', function() {
        if(!cphGlobal.cookiesEnabled()) return;
        let userEmail = cphGlobal.getCookie('auth_email') || cphGlobal.getCookie(cphPubAbbrev + '_email') || cphGlobal.getCookie('nl_email');
        if(!userEmail && window.Connext && window.Connext.Storage) {
            const userData = Connext.Storage.GetUserData() || {};
            userEmail = userData.Email;
        }
        if(!userEmail) {
            const postUpRecipientId = cphGlobal.getQueryStringParameter('pupeml');
            if(postUpRecipientId) {
                const request = $.get('https://api.pressdemocrat.com/upland/postup/subscriber/get.php', {
                    'rid'  : postUpRecipientId,
                    'rhash': cphGlobal.md5('rid: ' + postUpRecipientId)
                });
                request.done(function(data, textStatus, jqXHR) {
                    if((typeof data === 'object') && jqXHR.status === 200) {
                        userEmail = (data.address || '').toLowerCase();
                        if(userEmail) {
                            cphGlobal.setCookie('nl_email', userEmail, 30);
                            if(window.matherData) window.matherData.email = userEmail;
                        }
                    }
                });
            }
        }
    });
})(jQuery);
jQuery(function($) {
    var menus = $('.multi-level-menu'),
        hasChildren = false;

    $.each(menus, function(menu) {
        var uls = $(this).is('ul') ? $(this) : $(this).children('ul');

        $.each(uls, function() {
            var topLevels = $(this);
            topLevels.children('li').addClass('top-level');
            topLevels.find('ul').each(function(level) {
                hasChildren = true;

                var ul = $(this),
                    li = ul.closest('li'),
                    toggle = $('<span class="sub-menu-toggle"></span>');
                li.addClass('has-sub-menu').append(toggle);

                toggle.click(function() {
                    if(li.hasClass('sub-menu-visible')) {
                        li.removeClass('sub-menu-visible').find('.sub-menu-visible').removeClass('sub-menu-visible');
                    } else {
                        var thisParents = li.parentsUntil(topLevels[level], 'li.sub-menu-visible');
                        $(menus[menu]).find('.sub-menu-visible').not(thisParents).each(function() {
                            $(this).removeClass('sub-menu-visible');
                        });

                        if(li.is('.top-level')) {
                            var liMid = li.offset().left + (li.outerWidth() / 2),
                                sideClass = liMid > ($(window).width() / 2) ? 'menu-left' : 'menu-right';
                            li.removeClass('menu-left menu-right').addClass(sideClass);
                        }
                        li.addClass('sub-menu-visible');
                    }
                });
            });
        });
        $(document).on('closeChildMenus', function(e, originalEvent) {
            if($(originalEvent.target).closest(uls).length)
                return;

            $(menus[menu]).find('.sub-menu-visible').removeClass('sub-menu-visible');
        });
    });
    if(hasChildren) {
        $(document.body).click(function(e) {
            $(document).trigger('closeChildMenus', e);
        });
    }
});
if(!cphSCG && !cphLPS) {
    jQuery(function($) {
        var isPreview = cphGlobal.getQueryStringValueByKey('notiPreview') === 'true',
            getVersion = isPreview ? 'preview' : 'live',
            cacheTicks = isPreview ? Math.random() : Math.floor(new Date().getMinutes() / 5); // re-cache every 5 minutes if not preview version

        $.getJSON('https://api.pressdemocrat.com/_data/notifications/' + cphPubAbbrev + '-' + getVersion + '.json?cache=' + cacheTicks).done(function(data) {
            if(data.length) {
                $.each(data, function(i, v) {
                    cphGlobal.buildNotification(v.id, v.type, v.position, v.priority, v.html, v.closeFor, v.hideIcon, v.outerClass || '');
                });
            }
        });
    });
}
jQuery(function($) {
    let menu = $('#ttt-push-menu'),
        toggle = $('#ttt-push-menu-toggle'),
        openIcon = $('#ttt-push-menu-toggle-open'),
        closeIcon = $('#ttt-push-menu-toggle-close'),
        overlay = $('#ttt-push-menu-overlay'),
        links = menu.find('li.menu-item-has-children > a'),
        body = $(document.body);

    menu.attr('tabindex', '-1');
    overlay.attr('tabindex', '0');

    let closeSubmenu = function(link) {
        let submenu = link.next('ul');
        submenu.css('height', submenu.height());
        setTimeout(function() {
            link.attr('aria-expanded', 'false');
            submenu.css('height', '0');
        });
    };

    let closeMenu = function() {
        $(document).add(menu).off('.headerPushMenu');
        body.removeClass('push-menu--expanded');
        toggle.attr('aria-expanded', 'false');
        closeIcon.addClass('hide');
        openIcon.removeClass('hide');
        toggle.focus();
        links.filter('[aria-expanded="true"]').each(function() {
            closeSubmenu($(this));
        });
    };

    toggle.add(overlay).on('click', function() {
        let isExpanded = toggle.is('[aria-expanded="true"]');
        if(isExpanded) {
            closeMenu();
        } else {
            openIcon.addClass('hide');
            closeIcon.removeClass('hide');
            body.addClass('push-menu--expanded');
            toggle.attr('aria-expanded', 'true');
            menu.focus();

            $(document).add(menu).off('.headerPushMenu');

            menu.on('focusout.headerPushMenu', function(e) {
                if(!$(e.relatedTarget).is(toggle)) {
                    setTimeout(function() {
                        if(!$.contains(menu[0], document.activeElement)) {
                            closeMenu();
                        }
                    });
                }
            });

            $(document).on('keydown.headerPushMenu', function(e) {
                if(e.key === 'Escape') {
                    closeMenu();
                }
            });

            $(document).on('click.headerPushMenu', function(e) {
                if($(e.target).is(toggle))
                    return;
                if($(e.target).closest(toggle).length)
                    return;
                if($(e.target).is(menu))
                    return;
                if($(e.target).closest(menu).length)
                    return;

                closeMenu();
            });
        }
    });

    links.closest('li').each(function() {
        let link = $(this).find('> a'),
            submenu = link.next('ul');

        submenu.data('height', submenu.height());
        link.attr('href', 'javascript:void(0);'); // leave after setting data-height
        link.attr('aria-expanded', 'false'); // leave after setting data-height
    });

    links.on('click', function(e) {
        e.preventDefault();

        let link = $(this),
            isExpanded = link.is('[aria-expanded="true"]');

        if(isExpanded) {
            let parent = link.closest('li'),
                openLinks = parent.find('a[aria-expanded="true"]');

            openLinks.each(function() {
                closeSubmenu($(this));
            });
        } else {
            let submenu = link.next('ul');

            link.attr('aria-expanded', 'true');
            submenu.css('height', submenu.data('height'));
            submenu.one('transitionend', function() {
                submenu.css('height', 'auto');
            });

            let parent = link.closest('li'),
                parents = parent.parentsUntil(menu, 'li'),
                toClose = menu.find('a[aria-expanded="true"]').not(link).closest('li').not(parents);

            toClose.find('a[aria-expanded="true"]').each(function() {
                closeSubmenu($(this));
            });
        }
    });
});

if(cphPD) {
    // FOR MATHER: pass user email to SMAG if identified on PD
    (function($) {
        $(document).on('mouseup contextmenu click', 'a', function() {
            var link = $(this),
                href = link.attr('href'),
                emailValue = $.trim(cphGlobal.getCookieByName('pd_email')).toLowerCase();

            emailValue = (emailValue === 'info@pressdemocrat.com') ? null : emailValue;
            if(emailValue && href.indexOf('sonomamag.com') !== -1 && href.indexOf('utm_id=') === -1) {
                href = cphGlobal.updateQueryStringParameter('utm_id', btoa(emailValue), href);
                link.attr('href', href);
            }
        });
    })(jQuery);
}

// hide audio widget until user is subscribed on PD, PAC & SIT
jQuery(function($) {
    if(!(cphPD || cphSIT || cphPAC)) return;

    const widget = $('#trinity-audio-widget');
    if(!widget.length) return;

    widget.hide();

    if($('body').hasClass('circ-subscribed')) {
        widget.show();
    }

    $(document).on('mg2:subscribed', function() {
        widget.show();
    });
});

// START: SCROLL TO AND FOCUS ANCHOR LINKS
jQuery(function($) {
    const observer = new IntersectionObserver(function(entries) {
        let [entry] = entries;
        if(entry.isIntersecting) {
            entry.target.focus();
        }
    });

    $('a[href*="#"]').not('[href="#"]').not('[href*="#!"]').on('click', function(e) {
        let target = $(this.hash);
        if(!target.length) return;

        e.preventDefault();

        if(!target.isFocusable())
            target.attr('tabindex', '0').css('scroll-margin-top', '4em');

        const header = $('header.header');
        if(header.css('position') === 'fixed')
            target.css('scroll-margin-top', header.outerHeight() + 10);

        observer.observe(target[0]);
        target[0].scrollIntoView();
    });
});
// END: SCROLL TO AND FOCUS ANCHOR LINKS

// START: LOAD SOUNDCITE SCRIPT IF NEEDED
jQuery(function($) {
    $('.soundcite').each(function() {
        cphLoader.loadSoundcite();
    });
});
// END: LOAD SOUNDCITE SCRIPT IF NEEDED

// START: LOAD PDFEMBED SCRIPT IF NEEDED
jQuery(function($) {
    $('.pdf-embed').each(function(i) {
        var pdfId = 'pdf-embed-' + i,
            pdfSrc = $(this).data('src');

        $(this).attr('id', pdfId);

        cphLoader.loadPdfObject(function() {
            PDFObject.embed(pdfSrc, '#' + pdfId);
        });
    });
});
// END: LOAD PDFEMBED SCRIPT IF NEEDED

// START: LOAD FACEBOOK SDK IF NEEDED
jQuery(function($) {
    if($('.fb-video, .fb-post').length) {
        if(!$('div#fb-root').length) {
            $('body').prepend('<div id="fb-root"></div>');
        }
        if(!$('#facebook-jssdk').length) {
            (function(d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if(d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2&appId=10150152840220381&autoLogAppEvents=1';
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        }
    }
});
// END: LOAD FACEBOOK SDK IF NEEDED

// START: CHECK IF AUTOIFRAME SHORTCODES EXIST
jQuery(function($) {
    var autoFrames = $('.auto-size-iframe');
    if(!autoFrames.length)
        return;

    $.each(autoFrames, function(i, v) {
        window.addEventListener('message', function(event) {
            var data = event.data;
            if(data.message === 'cphResizeAutoIframe') {
                if(data.height) {
                    $(autoFrames[i]).attr('height', data.height);
                    $(autoFrames[i]).css({height: data.height + 'px'});
                }
            }
        }, false);
    });
});
// END: START: CHECK IF AUTOIFRAME SHORTCODES EXIST
jQuery(function($) {
    let navScrolls = $('.scrollable-menu');
    navScrolls.on('wheel', function(e) {
        let scrollable = e.currentTarget,
            width = scrollable.offsetWidth,
            scrollWidth = scrollable.scrollWidth,
            maxScroll = scrollWidth - width,
            scrollLeft = scrollable.scrollLeft,
            deltaY = e.originalEvent.deltaY,
            isScrollRight = deltaY > 0;

        if(scrollWidth <= width) return; // scroll not available
        if(maxScroll <= 0) return; // no max scroll (redundant with above)
        if(deltaY === 0) return; // using left/right scroll wheel
        if(isScrollRight && (scrollLeft >= maxScroll)) return; // scrolling right and max scroll reached
        if(!isScrollRight && (scrollLeft <= 0)) return; // scrolling left and min scroll reached

        e.preventDefault();

        scrollable.scrollLeft += deltaY;
    });
});

jQuery(function($) {
    $('.search-form').on('submit', function(e) {
        let form = $(this),
            submit = form.find('.search-form__submit'),
            searching = form.find('.search-form__searching'),
            input = form.find('input'),
            value = input.val().trim();

        if(form.data('is-submitting')) {
            e.preventDefault();
            return;
        }

        form.data('is-submitting', true);

        input.val(value);
        if(value) {
            submit.addClass('hide');
            searching.removeClass('hide');
            searching.addClass('spin');
            return;
        }

        e.preventDefault();
        input.focus();
        form.addClass('shake');
        setTimeout(function() {
            form.removeClass('shake');
            submit.removeClass('hide');
            searching.addClass('hide');
            searching.removeClass('spin');
            form.data('is-submitting', false);
        }, 350);
    });
});
(function($) {
    window.subscribedNewsletters = window.subscribedNewsletters || [];

    if(!cphGlobal.hasSessionStorage()) return;

    const getEmail = function() {
        return (cphGlobal.getEmail() || '').toLowerCase().trim();
    };

    const getSubscribedNewsletters = function(email) {
        if(!email) return null;
        const subscribedNewsletters = JSON.parse(sessionStorage.getItem('subscribedNewsletters') || '{}');
        if(email === subscribedNewsletters.email) return subscribedNewsletters.subscribed || [];
        return null;
    }

    const setSubscribedNewsletters = function(subscribedNewsletters) {
        sessionStorage.setItem('subscribedNewsletters', JSON.stringify(subscribedNewsletters || {}));
    }

    const removeSubscribedNewsletters = function() {
        sessionStorage.removeItem('subscribedNewsletters');
    }

    window.subscribedNewsletters = getSubscribedNewsletters(getEmail());

    $(document).one('mg2:loggedOut', removeSubscribedNewsletters);

    if(window.subscribedNewsletters !== null) return;

    $(function() {
        $(document).one('mg2:loggedIn mg2:subscribed mg2:notSubscribed mg2:failed', function() {
            const email = getEmail();
            if(!email) return;
            const request = $.getJSON(cphNlHost + '/api/subscriber/get/lists', {email:email});
            request.done(function(data, status, jqXHR) {
                if(jqXHR.status === 200 && data.email) {
                    setSubscribedNewsletters(data || {});
                    window.subscribedNewsletters = getSubscribedNewsletters(data.email);
                }
            });
        });
    });
})(jQuery);

window.vfQ = window.vfQ || [];

jQuery(function($) {
    // inject conversation starter before #inline-promo element

    // skip engagement starter if less than 7 paragraphs
    const paragraphs = $('.pw-section > p');
    if(paragraphs.length < 7) return;

    let vfConversationStarterCalled = false;
    $(document).on('articleInlinePromo:loaded', function(e, promoSlot) {
        promoSlot = $(promoSlot);
        if(!promoSlot.is('#inline-promo-1, #inline-promo-mid, #inline-promo-end')) return;

        const isVf = $('meta[name="vf:container_id"]').length;
        if(!isVf) return;

        const hasComments = $('#comments:visible').length;
        if(!hasComments) return;

        if(vfConversationStarterCalled) return;
        vfConversationStarterCalled = true;

        window.vfQ.push(function() {
            window.vf.$subscribe('vf-ads', 'requestConversationStarter', function(slotName) {
                const el = $('#' + slotName);

                if(cphGlobal.isSubscriber() && $(window).width() < 600) {
                    el.closest('.vf-conversation-starter__ad').remove();
                    return;
                }

                let ad = smiDfp.buildAd('phone,tablet,desktop');
                ad.addTargeting('vendor', 'vf-cs');
                ad.addSize(300, 250);
                el.html(ad.render());
                setTimeout(function() {
                    smiDfp.loadAds(el);
                }, 500);
            });
        });

        const figure = cphGlobal.wrapWithFigure('<div class="padded container"> <div class="viafoura"> <vf-conversation-starter target="comments"></vf-conversation-starter> </div> </div>');

        const wrapped = cphGlobal.wrapFigures(figure, 'large', 'center');

        wrapped.addClass('do-not-blur');
        wrapped.insertBefore(promoSlot);
        promoSlot.remove();
    });
});

jQuery(function() {
    const vf = {};
    const _vf = {};

    vf.cookie = {};
    vf.cookie.name = 'vf_session'; // add to CookieScript required cookies if new sites added
    vf.authType = 'subscribe'; // 'subscribe' OR 'register'

    vf.suppressedEmails = [
        'info@' + cphDomain,
        'judging@' + cphDomain,
        'journalism@pressdemocrat.com',
        'XXXnewsroom@' + cphDomain
        // make sure to enter new as all lowercase
    ];

    vf.suppressedDomains = [
        'domain.tld'
    ];

    vf.cookie.set = function(value) {
        cphGlobal.setCookie(vf.cookie.name, value, 1);
    };

    vf.cookie.get = function() {
        return cphGlobal.getCookieByName(vf.cookie.name);
    };

    vf.cookie.delete = function() {
        cphGlobal.deleteCookie(vf.cookie.name);
    };

    vf.resetVars = function() {
        _vf.email = null;
        _vf.sessionId = null;
        _vf.isSuppressed = null;
        _vf.isAuthenticated = null;
        _vf.isSuspended = null;
        _vf.isSuspendedHtml = null;
        _vf.validName = null;
        _vf.nameList = [];
        _vf.badList = [];
        _vf.avatarUrls = {};
        _vf.avatarUrl = null;
    };

    vf.getUrl = function() {
        return window.siteConfig?.pub?.vfRegister || 'https://vfregister.pressdemocrat.com';
    };

    vf.hasConnext = function() {
        return typeof Connext === 'object' && typeof Connext.Storage === 'object' && Connext.Storage.GetUserState().length;
    };

    vf.getLightboxBaseConfig = function() {
        if(!$('style#vf-lightbox').length) {
            const style = $('<style id="vf-lightbox"/>').appendTo('head');
            style.append('body.vf-lightbox--visible .dfp-wrap, body.vf-lightbox--visible .dfp-wrap * { visibility:hidden;pointer-events:none !important; }');
            style.append('body.vf-lightbox--visible .dfp-slot, body.vf-lightbox--visible .dfp-slot * { visibility:hidden;pointer-events:none !important; }');
            style.append('body.vf-lightbox--visible .vf-tray-widget { display: none; }');
        }

        $(document.body).addClass('vf-lightbox--visible');
        setTimeout(function() {
            window.vf.$publish('tray', 'close');
        });

        const zIndexes = [];
        zIndexes.push(parseInt($('.vf-tray-slide-wrapper:first').css('z-index')) || 100);
        zIndexes.push(100000);

        return {
            outerClass : 'vf-lightbox',
            zIndex : Math.max(...zIndexes) + 1,
            onInit : function() {
                $(document.body).addClass('vf-lightbox--visible');
            },
            onClose: function() {
                $(document.body).removeClass('vf-lightbox--visible');
            }
        };
    };

    vf.authenticationLightbox = function() {
        const lightboxBaseConfig = vf.getLightboxBaseConfig();
        cphLoader.loadCphLightbox(function() {
            console.log('VF: Opening authentication modal');

            const buttons = [];
            if(vf.hasConnext() && Connext.Storage.GetUserState() === 'Logged Out') {
                buttons.push(cphLightbox.button('Log In', {'data-mg2-action': 'login'}));
            } else {
                buttons.push(cphLightbox.button('Link Account', {'data-mg2-action': 'activation'}));
            }

            let dialogContent, dialogTitle;
            if(vf.authType === 'register') {
                dialogContent = 'You need to log in or register to access this feature.';
                dialogTitle = 'Registered Users Only';
                buttons.push(cphLightbox.button('Register', {'data-mg2-action': 'register'}));
            } else {
                dialogContent = 'A subscription is required to access this feature.';
                dialogTitle = 'Subscribers Only';
                buttons.push(cphLightbox.button('Subscribe', null, function() {
                    location.href = (window.siteConfig && window.siteConfig.url && window.siteConfig.url.subscribe) ? window.siteConfig.url.subscribe : '#';
                }));
            }

            const lightboxConfig = $.extend(true, {}, lightboxBaseConfig, {
                content  : dialogContent,
                title    : dialogTitle,
                titleCss : 'background-color: var(--accent-color);',
                showClose: true,
                dialog   : {
                    buttons  : buttons,
                    buttonCss: 'color: #222222;'
                }
            });

            cphLightbox.hideAll();
            $(document.body).cphDialog(lightboxConfig);
        });
    };

    vf.registrationLightbox = function() {
        const lightboxBaseConfig = vf.getLightboxBaseConfig();
        cphLoader.loadCphLightbox(function() {
            console.log('VF: Opening registration modal');

            const buttons = [];
            buttons.push(cphLightbox.button('Submit', {id: 'vf-create-submit', class: 'disabled'}, function() {
                cphLightbox.get(this).find('form').submit();
            }, false));

            const lightboxConfig = $.extend(true, {}, lightboxBaseConfig, {
                content  : vf.buildRegistrationForm(),
                width    : 300,
                title    : 'Create your screen name',
                titleCss : 'background-color: var(--accent-color);',
                showClose: true,
                dialog   : {
                    buttons  : buttons,
                    buttonCss: 'color: #222222;'
                }
            });

            cphLightbox.hideAll();
            $(document.body).cphDialog(lightboxConfig);
        });
    };

    vf.isSuppressedLightbox = function() {
        const lightboxBaseConfig = vf.getLightboxBaseConfig();
        cphLoader.loadCphLightbox(function() {
            console.log('VF: Opening isSuppressed modal');

            const lightboxConfig = $.extend(true, {}, lightboxBaseConfig, {
                content : 'This feature has been disabled for this account.',
                width   : 300,
                title   : 'Please note',
                titleCss: 'background-color: red;'
            });

            cphLightbox.hideAll();
            $(document.body).cphDialog(lightboxConfig);
        });
    };

    vf.isSuspendedLightbox = function() {
        const lightboxBaseConfig = vf.getLightboxBaseConfig();
        cphLoader.loadCphLightbox(function() {
            console.log('VF: Opening isSuspended modal');

            const lightboxConfig = $.extend(true, {}, lightboxBaseConfig, {
                content : _vf.isSuspendedHtml,
                width   : 500,
                title   : 'Please note',
                titleCss: 'background-color: red;'
            });

            cphLightbox.hideAll();
            $(document.body).cphDialog(lightboxConfig);
        });
    };

    vf.scrubName = function(name) {
        name = name.toLowerCase();
        name = name.replace(/\s/g, '');
        return name.replace(/-/g, '');
    };

    vf.getLists = function(callback) {
        if(_vf.nameList.length && _vf.badList.length) {
            callback.call();
        } else {
            $.when(
                $.get(vf.getUrl() + '/usernames.txt?time=' + (new Date()).getTime()),
                $.get(vf.getUrl() + '/badwords.txt?time=' + (new Date()).getTime())
            ).done(function(r1, r2) {
                _vf.nameList = (r1.shift() || '').toLowerCase().split(',').map(function(name) {
                    return vf.scrubName(name);
                });
                _vf.badList = (r2.shift() || '').toLowerCase().split(',');
                callback.call();
            });
        }
    };

    vf.buildRegistrationForm = function() {
        if(!$('style#vf-registration-lightbox').length) {
            const style = $('<style id="vf-registration-lightbox"/>').appendTo('head');

            style.append('.vf-create{position:relative;max-width:300px;}');
            style.append('.vf-create p{line-height:1.15em;margin:0 0 1em;}');
            style.append('.vf-create__form{margin:0 auto;text-align:center;}');
            style.append('.vf-create__row{position:relative;display:flex;justify-content:space-between;align-items:center;height:70px;margin:auto;}');
            style.append('.vf-create__item{transition:border-color 350ms;border-radius:3px;cursor:pointer;outline-offset:5px;}');
            style.append('.vf-create__item:focus{outline:2px solid blue;}');
            style.append('.vf-create__item--selected{outline:2px solid red !important;}');
            style.append('.vf-create__item>img{display:block;height:50px;width:50px;min-width:50px;}');
            style.append('.vf-create__item-text{margin: 0 0 0 1em;text-align:left;font-size:.9em;}');
            style.append('.vf-create__item-text a{color:inherit;text-decoration:underline;}');
            style.append('.vf-create__heading{font-size:1.1em;font-weight:bold;margin:1em 0 .35em;}');
            style.append('.vf-create__name-error{font-size:0.9em;color:red;margin-bottom:.35em;}');
            style.append('#vf-create-submit.disabled{opacity:.2;pointer-events:none;}');
        }

        const container = $('<div class="vf-create"/>');
        const loader = $('<div class="top-loader"><span></span></div>').appendTo(container);
        const form = $('<form class="vf-create__form"/>').appendTo(container);

        const sessionId = vf.sessionId();
        const avatarUrls = vf.getAvatarUrls(sessionId);
        let html = '';

        html += '<p>Please choose a display name and image to use when commenting or interacting with comments.</p>';
        html += '<p style="font-size:.85em; color:#003CFF;">This can\'t be changed, choose wisely!</p>';

        html += '<h4 class="vf-create__heading">Display Name</h4>';

        html += '<input type="text" name="displayName" maxlength="24" size="24" tabindex="0" value="" autocomplete="off">';

        html += '<div class="vf-create__name-error"></div>';

        html += '<h4 class="vf-create__heading">Display Image</h4>';

        html += '<div class="vf-create__row" style="align-items:flex-start;height:auto;">';

        html += '<div class="vf-create__item" tabindex="0" data-index="0">';
        html += '<img src="' + avatarUrls[0] + '" alt="img 0"/>';
        html += '</div>';

        html += '<p class="vf-create__item-text">';
        html += '(This icon can be updated by visiting <a href="https://en.gravatar.com/" target="_blank">Gravatar.com</a> using your account login email)';
        html += '</p>';

        html += '</div>';

        html += '<h4 class="vf-create__heading">';
        html += 'Other Image Choices';
        html += '</div>';

        const avatarRow = function(firstIndex) {
            let row = '<div class="vf-create__row">';
            for(let i = firstIndex; i < (firstIndex + 4); i++) {
                row += '<div class="vf-create__item" tabindex="0" data-index="' + i + '">';
                row += '<img src="' + avatarUrls[i] + '" alt="img ' + i + '" />';
                row += '</div>';
            }
            row += '</div>';
            return row;
        };

        html += avatarRow(1);
        html += avatarRow(5);
        html += avatarRow(9);
        html += avatarRow(13);

        form.html(html);

        const nameInput = form.find('[name="displayName"]').first();
        const nameError = form.find('.vf-create__name-error').first();

        const isValidSubmission = function() {
            return _vf.validName && _vf.avatarUrl && vf.email() && vf.sessionId();
        };

        form.on('submit', function(e) {
            e.preventDefault();

            if(!vf.formSubmitting) {
                vf.formSubmitting = true;

                $('#vf-create-submit').addClass('disabled');

                if(!isValidSubmission()) {
                    nameError.text('Make sure you have entered a display name and selected a display image.');
                    vf.formSubmitting = false;
                    return;
                }

                console.log('VF: Registering user');

                loader.addClass('show');

                const getUrl = vf.getUrl() + '/register_me.php';
                const get = $.get(getUrl, {
                    session: vf.sessionId(),
                    email  : vf.email(),
                    name   : _vf.validName,
                    avatar : _vf.avatarUrl
                });

                get.done(function(data) {
                    console.log('VF: Submission status: ' + data);

                    if(data === 'ok') {
                        cphLightbox.hideAll();
                        console.log('VF: Registration complete');
                        vf.renewInstance();
                        return;
                    }

                    console.log('VF: Registration failed');
                });

                get.fail(function() {
                    console.log('VF: Registration failed');
                });

                get.always(function() {
                    _vf.RegFormSubmitting = false;
                    loader.removeClass('show');
                });
            }
        });

        const checkName = function(debounceTimeout) {
            clearTimeout(vf.nameBlurDebounce);
            vf.nameBlurDebounce = setTimeout(function() {
                _vf.validName = false;

                const submitButton = $('#vf-create-submit');

                let name = nameInput.val();
                name = name.replace(/\s+/, ' ');
                name = name.replace(/-+/, '-');
                name = name.trim();

                nameInput.val(name);

                nameError.empty();
                submitButton.addClass('disabled');

                if(!name.length) return;

                if(!(/^[a-zA-Z0-9\s\-]+$/.test(name))) {
                    nameError.text('Names can only contain numbers, letters, spaces and dashes');
                    return;
                }

                const scrubbedName = vf.scrubName(name);

                // check if name is already used or not allowed, regardless of case
                if(_vf.nameList.indexOf(scrubbedName) !== -1) {
                    nameError.text('Sorry, that name has been taken');
                    return;
                }

                // check if banned words are used anywhere in the name
                let hasBadWords = false;
                $.each(_vf.badList, function(i, word) {
                    if(scrubbedName.indexOf(word) !== -1) {
                        nameError.text('That name is not allowed');
                        hasBadWords = true;
                        return false;
                    }
                });

                if(hasBadWords) return;

                _vf.validName = name;

                if(isValidSubmission()) submitButton.removeClass('disabled');
            }, debounceTimeout);
        };

        vf.getLists(function() {
            nameInput.on('focus blur keyup', function(e) {
                if(e.type === 'focus') {
                    nameError.empty();
                    return;
                }

                if(e.type === 'blur') {
                    checkName(0);
                    return;
                }

                checkName(600);
            });
        });

        const pickItems = form.find('.vf-create__item');
        pickItems.on('click keydown', function(e) {
            if(e.type === 'keydown') {
                if(!(e.keyCode === 13 || e.keyCode === 32 || e.key === 'Enter' || e.key === ' ')) {
                    return; // only continue if keydown is triggered by Spacebar or Enter
                }
            }

            const pickItem = $(this);
            const index = pickItem.data('index');
            const avatarUrl = avatarUrls[index] || null;

            if(!avatarUrl) return;

            pickItems.removeClass('vf-create__item--selected');
            pickItem.addClass('vf-create__item--selected');

            _vf.avatarUrl = avatarUrl;

            if(isValidSubmission()) $('#vf-create-submit').removeClass('disabled');
        });

        return container;
    };

    vf.getAvatarUrls = function(sessionId) {
        if(!_vf.avatarUrls[sessionId]) {
            const avatarUrls = [];

            console.log('VF: Fetching avatars for Session ID: ' + sessionId);

            const addAvatarUrl = function(md5, which) {
                avatarUrls.push('https://www.gravatar.com/avatar/' + md5 + '?s=50&d=' + which);
            };

            addAvatarUrl(sessionId, 'identicon');

            const addAvatarUrls = function(which) {
                let md5minus1 = sessionId.substring(0, sessionId.length - 1);
                for(let i = 0; i < 4; i++) {
                    let md5 = md5minus1 + i;
                    if(md5 === sessionId)
                        md5 = md5minus1 + (i + 4);
                    addAvatarUrl(md5, which);
                }
            };

            addAvatarUrls('identicon');
            addAvatarUrls('monsterid');
            addAvatarUrls('wavatar');
            addAvatarUrls('robohash');

            _vf.avatarUrls[sessionId] = avatarUrls;
        }

        return _vf.avatarUrls[sessionId];
    };

    vf.isAuthenticated = function() {
        if(_vf.isAuthenticated === null) {
            if(vf.hasConnext()) {
                const userState = Connext.Storage.GetUserState();
                if(vf.authType === 'register' && userState !== 'Logged Out') {
                    _vf.isAuthenticated = true;
                } else {
                    _vf.isAuthenticated = vf.authType === 'subscribe' && userState === 'Subscribed';
                }
            }
        }
        return _vf.isAuthenticated;
    };

    vf.isSuppressed = function() {
        if(_vf.isSuppressed === null) {
            const email = vf.email();
            _vf.isSuppressed = false;
            if(vf.suppressedEmails.indexOf(email) !== -1) {
                _vf.isSuppressed = true;
            } else if(vf.suppressedDomains.indexOf(email.split('@').pop()) !== -1) {
                _vf.isSuppressed = true;
            }
        }
        return _vf.isSuppressed;
    };

    vf.isSuspended = function() {
        return !!_vf.isSuspended;
    };

    vf.email = function(forceReset) {
        if(_vf.email !== null && !forceReset)
            return _vf.email;
        if(vf.hasConnext()) {
            _vf.email = (Connext.Storage.GetUserData().Email || '').trim().toLowerCase();
            console.log('VF: Email set:', _vf.email);
        }
        return _vf.email;
    };

    vf.sessionId = function(forceReset) {
        if(_vf.sessionId !== null && !forceReset)
            return _vf.sessionId;

        _vf.sessionId = false;
        if(vf.isAuthenticated()) {
            const email = vf.email(forceReset);
            if(email) {
                if(vf.isSuppressed()) {
                    console.log('VF: ' + email + ' is suppressed');
                } else {
                    _vf.sessionId = cphGlobal.md5(email);
                    console.log('VF: Session ID: ' + _vf.sessionId);
                }
            }
        }

        return _vf.sessionId;
    };

    vf.renewInstance = function() {
        if(!window.vf) return;
        console.log('VF: Renewing instance');
        vf.cookie.delete();
        window.vf.session.logout()
        .then(window.vf.context.teardown)
        .then(vf.init)
        .then(window.vf.context.setup);
    };

    vf.init = function(options) {
        options = options || {};
        console.log('VF: -------- Init called --------');

        vf.resetVars();

        window.vfQ = window.vfQ || [];
        window.vfQ.push(function() {
            const sessionId = vf.sessionId(true);
            if(sessionId) {
                console.log('VF: Logging in');
                window.vf.session.login.cookie(sessionId);
            } else if(options.isFallback && vf.cookie.get()) {
                console.log('VF: Logging in using cookie');
                window.vf.session.login.cookie(vf.cookie.get());
            } else {
                console.log('VF: Making sure user is logged out');
                vf.cookie.delete();
                window.vf.session.logout();
            }
        });

        if(!vf.initCalled) {
            vf.initCalled = true;
            console.log('VF: Setting vfQ items');
            window.vfQ.push(function() {
                window.vf.$subscribe('authentication', 'required', function(context) {
                    console.log('VF: authentication: required:', context.action);

                    const trigger = $(context.trigger);
                    let closestId = trigger.closest('[id]:not([id=""])').attr('id');
                    if(closestId) {
                        if(closestId.indexOf('vf-all_threads-') === 0)
                            closestId = closestId.replace('vf-all_threads-', 'vf-').replace(/-list$/, '');
                        window.history.replaceState(null, document.title, '#' + closestId);
                    }

                    if(vf.isAuthenticated()) {
                        if(vf.isSuppressed()) {
                            vf.isSuppressedLightbox();
                        } else if(vf.isSuspended()) {
                            vf.isSuspendedLightbox();
                        } else {
                            vf.registrationLightbox();
                        }
                    } else {
                        vf.authenticationLightbox();
                    }
                });

                window.vf.$subscribe('login', 'success', function(user) {
                    console.log('VF: User name:', user.name);
                    if(user.social_login_provider === 'Viafoura Defined Cookie')
                        vf.cookie.set(user.social_login_id);
                    //console.log('VF: User:', user);
                    // user.ban_level: "posting"
                    // user.ban_level: "ghost"
                    // user.ban_level: "none"
                    $('#vf-comments-ban-reason').hide();
                });

                window.vf.$subscribe('logout', 'success', function() {
                    console.log('VF: logged out');
                    vf.cookie.delete();
                    //if(vf.hasConnext()) Connext.Logout(); // can't do this because it causes refresh loops. Maybe look at Connext if logged in, then do this.
                });

                window.vf.$subscribe('login', 'failure', function(errorContext) {
                    //console.log('VF: login failed:', errorContext);
                    if(errorContext.http_status === 401) {
                        console.log('VF: login failed: no account');
                        return;
                    }

                    if(errorContext.error_key === 'login_banned') {
                        const banHtmls = [];
                        const banHeading = '<h4>Please note</h4>';
                        if(errorContext.isPermanent === 1) {
                            console.log('VF: login failed: permanent suspension');
                            banHtmls.push('<p>Access to this feature has been permanently suspended.</p>');
                        } else {
                            console.log('VF: login failed: temporary suspension');
                            if(errorContext.reason) {
                                banHtmls.push('<p>Access to this feature has been temporarily suspended for the following reason(s):</p>');
                                banHtmls.push('<p class="vf-banned__reason" style="line-height:1.2;font-size:.95em;"><em style="color: #666666;">' + errorContext.reason.replace(/\n/g, '<br>') + '</em></p>');
                            } else {
                                banHtmls.push('<p>Access to this feature has been temporarily suspended.</p>');
                            }
                            const expireDate = new Date(errorContext.endDate);
                            banHtmls.push('<p style="font-size:.8em;color:#444444;">The suspension will expire ' + expireDate.toLocaleString().replace(',', ' at') + '.</p>');
                        }
                        const banHtml = banHtmls.join('');
                        $('#vf-comments-ban-reason').html([banHeading, banHtml]).show();
                        _vf.isSuspended = true;
                        _vf.isSuspendedHtml = banHtml;
                    }
                });
            });
        } else if(options.forceRenewIfLoaded) {
            vf.renewInstance();
            return;
        }

        $(document).trigger('vf:loaded');
    };

    vf.resetVars();

    if(vf.hasConnext()) {
        console.log('VF: Running Init: Connext');
        vf.loading = true;
        vf.init();
    }

    $(document).one('mg2:loaded mg2:failed', function(e) {
        if(!vf.loading) {
            console.log('VF: Running Init:', e.type);
            vf.loading = true;
            vf.init({forceRenewIfLoaded:true});
        }
    });

    // trigger fallback after 7 seconds if no Connext event
    setTimeout(function() {
        if(!vf.loading) {
            console.log('VF: Running Init: fallback');
            vf.init({isFallback:true});
        }
    }, 7000);

    // if, after 12 seconds, comments aren't showing, force again.
    setTimeout(function() {
        const vfElement = $('vf-conversations');
        if(vfElement.length && vfElement.empty()) {
            vf.resetVars();
            vf.renewInstance();
        }
    }, 12000);
});

/*
jQuery(function() {
    window.vfQ.push(function() {
        /**
         * Viafoura events fired
         *
         * U: in console is for 'untested' or 'unworking' ;-)
         *
         * https://documentation.viafoura.com/docs/viafoura-events
         *//*

        window.vf.$subscribe('authentication', 'required', function(context) {
            console.log('VF: authentication: required:', context.action);
        });

        window.vf.$subscribe('commenting', 'loaded', function(el) {
            console.log('VF: commenting: loaded:', el);
        });

        window.vf.$subscribe('comments', 'read', function(el) {
            console.log('VF: comments: read:', el);
        });

        window.vf.$subscribe('comments', 'engage', function(context) {
            console.log('VF: comments: engage:', context.widget, context.commentCount);
        });

        window.vf.$subscribe('vf-tray-trigger', 'clicked', function() {
            console.log('VF: vf-tray-trigger: clicked');
        });

        window.vf.$subscribe('vf-tray-trigger', 'loaded', function(el) {
            console.log('VF: vf-tray-trigger: loaded:', el);
        });

        window.vf.$subscribe('vf-tray', 'loaded', function(el) {
            console.log('VF: vf-tray: loaded:', el);
        });

        window.vf.$subscribe('tray', 'opened', function(tabName) {
            console.log('VF: tray: opened:', tabName);
        });

        window.vf.$subscribe('tray', 'closed', function() {
            console.log('VF: tray: closed');
        });

        window.vf.$subscribe('user-notifications', 'new-count-changed', function(notificationCount) {
            console.log('VF: user-notifications: new-count-changed:', notificationCount);
        });

        window.vf.$subscribe('profile', 'show', function(clicked, user) {
            // view profile of other user
            console.log('VF: profile: show:', clicked, user);
        });

        window.vf.$subscribe('user', 'loaded', function(user) {
            console.log('VF: user: loaded:', user);
        });

        window.vf.$subscribe('login', 'success', function(user, type) {
            console.log('VF: login: success:', type, user);
        });

        window.vf.$subscribe('login', 'failure', function(errorContext, loginContext) {
            console.log('VF: login: failure:', errorContext, loginContext);
        });

        window.vf.$subscribe('logout', 'success', function() {
            console.log('VF: logout: success');
        });

        window.vf.$subscribe('comment', 'created', function(context) {
            console.log('VF: comment: created:', context);
        });

        window.vf.$subscribe('comment-reply', 'posted', function(context) {
            console.log('VF: comment-reply: posted:', context);
        });

        window.vf.$subscribe('topics', 'loaded', function(topics) {
            // TODO: need to look into topics a bit further
            console.log('VF: topics: loaded:', topics);
        });

        window.vf.$subscribe('topics', 'followed', function(context) {
            console.log('VF: topics: followed:', context);
        });

        window.vf.$subscribe('topics', 'unfollowed', function(topicId) {
            console.log('VF: topics: unfollowed:', topicId);
        });

        /*
        BELOW ONLY FIRE FOR VF AUTHENTICATION (UNUSED)

        window.vf.$subscribe('authentication', 'login', function(a, b, c, d) {
            console.log('VF: U: authentication: login:', a, b, c, d);
        });

        window.vf.$subscribe('authentication', 'logout', function(a, b, c, d) {
            console.log('VF: U: authentication: login:', a, b, c, d);
        });

        window.vf.$subscribe('authentication', 'logout/failure', function(a, b, c, d) {
            console.log('VF: U: authentication: logout/failure:', a, b, c, d);
        });

        window.vf.$subscribe('authentication', 'signup', function(a, b, c, d) {
            console.log('VF: U: authentication: signup:', a, b, c, d);
        });

        window.vf.$subscribe('authentication', 'signup/failure', function(a, b, c, d) {
            console.log('VF: U: authentication: signup/failure:', a, b, c, d);
        });

        BELOW ONLY FIRED BY SHAREBAR (UNUSED)

        window.vf.$subscribe('share', 'clicked', function(a, b, c, d) {
            console.log('VF: U: share: clicked:', a, b, c, d);
        });

        window.vf.$subscribe('share-total', 'loaded', function(a, b, c, d) {
            console.log('VF: U: share-total: loaded:', a, b, c, d);
        });
        *//*
    });
});
*/
jQuery(function($) {
    let weatherLink = $('#ttt-header-weather-widget:visible');
    if(!weatherLink.length) return;

    let cacheTicks = Math.floor(new Date().getMinutes() / 5); // re-cache every 5 minutes

    let json = $.getJSON('https://feeds.' + cphDomain + '/' + cphFeedDir + '/wex/feed.json?cache=' + cacheTicks);

    json.done(function(data) {
        let icon = weatherLink.find('.weather-icon'),
            temp = weatherLink.find('.weather-temp');

        let iconNum = data[0].WeatherIcon,
            iconTemp = data[0].Temperature.Imperial.Value;
        icon.removeClass().addClass('weather-icon icon-' + iconNum);
        temp.text(iconTemp + '°');
    });
});